export const billingRarcCodes = [
  {
    code: 'M1',
    description:
      'X-ray not taken within the past 12 months or near enough to the start of treatment.',
  },
  {
    code: 'M2',
    description: 'Not paid separately when the patient is an inpatient.',
  },
  {
    code: 'M3',
    description:
      'Equipment is the same or similar to equipment already being used.',
  },
  {
    code: 'M4',
    description:
      'Alert: This is the last monthly installment payment for this durable medical equipment.',
  },
  {
    code: 'M5',
    description:
      'Monthly rental payments can continue until the earlier of the 15th month from the first rental month, or the month when the equipment is no longer needed.',
  },
  {
    code: 'M6',
    description:
      'Alert: You must furnish and service this item for any period of medical need for the remainder of the reasonable useful lifetime of the equipment.',
  },
  {
    code: 'M7',
    description:
      'No rental payments after the item is purchased, returned or after the total of issued rental payments equals the purchase price.',
  },
  {
    code: 'M8',
    description:
      'We do not accept blood gas tests results when the test was conducted by a medical supplier or taken while the patient is on oxygen.',
  },
  {
    code: 'M9',
    description:
      'Alert: This is the tenth rental month. You must offer the patient the choice of changing the rental to a purchase agreement.',
  },
  {
    code: 'M10',
    description:
      'Equipment purchases are limited to the first or the tenth month of medical necessity.',
  },
  {
    code: 'M11',
    description:
      "DME, orthotics and prosthetics must be billed to the DME carrier who services the patient's zip code.",
  },
  {
    code: 'M12',
    description:
      'Diagnostic tests performed by a physician must indicate whether purchased services are included on the claim.',
  },
  {
    code: 'M13',
    description:
      'Only one initial visit is covered per specialty per medical group.',
  },
  {
    code: 'M14',
    description:
      'No separate payment for an injection administered during an office visit, and no payment for a full office visit if the patient only received an injection.',
  },
  {
    code: 'M15',
    description:
      'Separately billed services/tests have been bundled as they are considered components of the same procedure. Separate payment is not allowed.',
  },
  {
    code: 'M16',
    description:
      'Alert: Please see our web site, mailings, or bulletins for more details concerning this policy/procedure/decision.',
  },
  {
    code: 'M17',
    description:
      'Alert: Payment approved as you did not know, and could not reasonably have been expected to know, that this would not normally have been covered for this patient. In the future, you will be liable for charges for the same service(s) under the same or similar conditions.',
  },
  {
    code: 'M18',
    description:
      "Certain services may be approved for home use. Neither a hospital nor a Skilled Nursing Facility (SNF) is considered to be a patient's home.",
  },
  {
    code: 'M19',
    description: 'Missing oxygen certification/re-certification.',
  },
  {
    code: 'M20',
    description: 'Missing/incomplete/invalid HCPCS.',
  },
  {
    code: 'M21',
    description:
      'Missing/incomplete/invalid place of residence for this service/item provided in a home.',
  },
  {
    code: 'M22',
    description: 'Missing/incomplete/invalid number of miles traveled.',
  },
  {
    code: 'M23',
    description: 'Missing invoice.',
  },
  {
    code: 'M24',
    description: 'Missing/incomplete/invalid number of doses per vial.',
  },
  {
    code: 'M25',
    description:
      'The information furnished does not substantiate the need for this level of service. If you believe the service should have been fully covered as billed, or if you did not know and could not reasonably have been expected to know that we would not pay for this level of service, or if you notified the patient in writing in advance that we would not pay for this level of service and he/she agreed in writing to pay, ask us to review your claim within 120 days of the date of this notice. If you do not request an appeal, we will, upon application from the patient, reimburse him/her for the amount you have collected from him/her in excess of any deductible and coinsurance amounts. We will recover the reimbursement from you as an overpayment.',
  },
  {
    code: 'M26',
    description:
      'The information furnished does not substantiate the need for this level of service. If you have collected any amount from the patient for this level of service/any amount that exceeds the limiting charge for the less extensive service, the law requires you to refund that amount to the patient within 30 days of receiving this notice.',
  },
  {
    code: 'M27',
    description:
      "Alert: The patient has been relieved of liability of payment of these items and services under the limitation of liability provision of the law. The provider is ultimately liable for the patient's waived charges, including any charges for coinsurance, since the items or services were not reasonable and necessary or constituted custodial care, and you knew or could reasonably have been expected to know, that they were not covered. You may appeal this determination. You may ask for an appeal regarding both the coverage determination and the issue of whether you exercised due care. The appeal request must be filed within 120 days of the date you receive this notice. You must make the request through this office.",
  },
  {
    code: 'M28',
    description:
      'This does not qualify for payment under Part B when Part A coverage is exhausted or not otherwise available.',
  },
  {
    code: 'M29',
    description: 'Missing operative note/report.',
  },
  {
    code: 'M30',
    description: 'Missing pathology report.',
  },
  {
    code: 'M31',
    description: 'Missing radiology report.',
  },
  {
    code: 'M32',
    description:
      "Alert: This is a conditional payment made pending a decision on this service by the patient's primary payer. This payment may be subject to refund upon your receipt of any additional payment for this service from another payer. You must contact this office immediately upon receipt of an additional payment for this service.",
  },
  {
    code: 'M33',
    description:
      'Missing/incomplete/invalid UPIN for the ordering/referring/performing provider.',
  },
  {
    code: 'M34',
    description: 'Claim lacks the CLIA certification number.',
  },
  {
    code: 'M35',
    description:
      'Missing/incomplete/invalid pre-operative photos or visual field results.',
  },
  {
    code: 'M36',
    description:
      'This is the 11th rental month. We cannot pay for this until you indicate that the patient has been given the option of changing the rental to a purchase.',
  },
  {
    code: 'M37',
    description: 'Not covered when the patient is under age 35.',
  },
  {
    code: 'M38',
    description:
      'Alert: The patient is liable for the charges for this service as they were informed in writing before the service was furnished that we would not pay for it and the patient agreed to be responsible for the charges.',
  },
  {
    code: 'M39',
    description:
      'Alert: The patient is not liable for payment of this service as the advance notice of non-coverage you provided the patient did not comply with program requirements.',
  },
  {
    code: 'M40',
    description:
      "Claim must be assigned and must be filed by the practitioner's employer.",
  },
  {
    code: 'M41',
    description:
      'We do not pay for this as the patient has no legal obligation to pay for this.',
  },
  {
    code: 'M42',
    description:
      'The medical necessity form must be personally signed by the attending physician.',
  },
  {
    code: 'M43',
    description:
      'Payment for this service previously issued to you or another provider by another carrier/intermediary.',
  },
  {
    code: 'M44',
    description: 'Missing/incomplete/invalid condition code.',
  },
  {
    code: 'M45',
    description: 'Missing/incomplete/invalid occurrence code(s).',
  },
  {
    code: 'M46',
    description: 'Missing/incomplete/invalid occurrence span code(s).',
  },
  {
    code: 'M47',
    description:
      'Missing/incomplete/invalid Payer Claim Control Number. Other terms exist for this element including, but not limited to, Internal Control Number (ICN), Claim Control Number (CCN), Document Control Number (DCN).',
  },
  {
    code: 'M48',
    description:
      'Payment for services furnished to hospital inpatients (other than professional services of physicians) can only be made to the hospital. You must request payment from the hospital rather than the patient for this service.',
  },
  {
    code: 'M49',
    description: 'Missing/incomplete/invalid value code(s) or amount(s).',
  },
  {
    code: 'M50',
    description: 'Missing/incomplete/invalid revenue code(s).',
  },
  {
    code: 'M51',
    description: 'Missing/incomplete/invalid procedure code(s).',
  },
  {
    code: 'M52',
    description: "Missing/incomplete/invalid 'from' date(s) of service.",
  },
  {
    code: 'M53',
    description: 'Missing/incomplete/invalid days or units of service.',
  },
  {
    code: 'M54',
    description: 'Missing/incomplete/invalid total charges.',
  },
  {
    code: 'M55',
    description:
      'We do not pay for self-administered anti-emetic drugs that are not administered with a covered oral anti-cancer drug.',
  },
  {
    code: 'M56',
    description: 'Missing/incomplete/invalid payer identifier.',
  },
  {
    code: 'M57',
    description: 'Missing/incomplete/invalid provider identifier.',
  },
  {
    code: 'M58',
    description:
      'Missing/incomplete/invalid claim information. Resubmit claim after corrections.',
  },
  {
    code: 'M59',
    description: "Missing/incomplete/invalid 'to' date(s) of service.",
  },
  {
    code: 'M60',
    description: 'Missing Certificate of Medical Necessity.',
  },
  {
    code: 'M61',
    description:
      'We cannot pay for this as the approval period for the FDA clinical trial has expired.',
  },
  {
    code: 'M62',
    description: 'Missing/incomplete/invalid treatment authorization code.',
  },
  {
    code: 'M63',
    description: 'We do not pay for more than one of these on the same day.',
  },
  {
    code: 'M64',
    description: 'Missing/incomplete/invalid other diagnosis.',
  },
  {
    code: 'M65',
    description:
      'One interpreting physician charge can be submitted per claim when a purchased diagnostic test is indicated. Please submit a separate claim for each interpreting physician.',
  },
  {
    code: 'M66',
    description:
      'Our records indicate that you billed diagnostic tests subject to price limitations and the procedure code submitted includes a professional component. Only the technical component is subject to price limitations. Please submit the technical and professional components of this service as separate line items.',
  },
  {
    code: 'M67',
    description: 'Missing/incomplete/invalid other procedure code(s).',
  },
  {
    code: 'M68',
    description:
      'Missing/incomplete/invalid attending, ordering, rendering, supervising or referring physician identification.',
  },
  {
    code: 'M69',
    description:
      'Paid at the regular rate as you did not submit documentation to justify the modified procedure code.',
  },
  {
    code: 'M70',
    description:
      'Alert: The NDC code submitted for this service was translated to a HCPCS code for processing, but please continue to submit the NDC on future claims for this item.',
  },
  {
    code: 'M71',
    description: 'Total payment reduced due to overlap of tests billed.',
  },
  {
    code: 'M72',
    description: 'Did not enter full 8-digit date (MM/DD/CCYY).',
  },
  {
    code: 'M73',
    description:
      'The HPSA/Physician Scarcity bonus can only be paid on the professional component of this service. Rebill as separate professional and technical components.',
  },
  {
    code: 'M74',
    description:
      'This service does not qualify for a HPSA/Physician Scarcity bonus payment.',
  },
  {
    code: 'M75',
    description:
      'Multiple automated multichannel tests performed on the same day combined for payment.',
  },
  {
    code: 'M76',
    description: 'Missing/incomplete/invalid diagnosis or condition.',
  },
  {
    code: 'M77',
    description: 'Missing/incomplete/invalid/inappropriate place of service.',
  },
  {
    code: 'M78',
    description: 'Missing/incomplete/invalid HCPCS modifier.',
  },
  {
    code: 'M79',
    description: 'Missing/incomplete/invalid charge.',
  },
  {
    code: 'M80',
    description:
      'Not covered when performed during the same session/date as a previously processed service for the patient.',
  },
  {
    code: 'M81',
    description:
      'You are required to code to the highest level of specificity.',
  },
  {
    code: 'M82',
    description: 'Service is not covered when patient is under age 50.',
  },
  {
    code: 'M83',
    description:
      'Service is not covered unless the patient is classified as at high risk.',
  },
  {
    code: 'M84',
    description:
      'Medical code sets used must be the codes in effect at the time of service.',
  },
  {
    code: 'M85',
    description:
      'Subjected to review of physician evaluation and management services.',
  },
  {
    code: 'M86',
    description:
      'Service denied because payment already made for same/similar procedure within set time frame.',
  },
  {
    code: 'M87',
    description: 'Claim/service(s) subjected to CFO-CAP prepayment review.',
  },
  {
    code: 'M88',
    description:
      'We cannot pay for laboratory tests unless billed by the laboratory that did the work.',
  },
  {
    code: 'M89',
    description: 'Not covered more than once under age 40.',
  },
  {
    code: 'M90',
    description: 'Not covered more than once in a 12 month period.',
  },
  {
    code: 'M91',
    description:
      'Lab procedures with different CLIA certification numbers must be billed on separate claims.',
  },
  {
    code: 'M92',
    description:
      'Services subjected to review under the Home Health Medical Review Initiative.',
  },
  {
    code: 'M93',
    description:
      'Information supplied supports a break in therapy. A new capped rental period began with delivery of this equipment.',
  },
  {
    code: 'M94',
    description:
      'Information supplied does not support a break in therapy. A new capped rental period will not begin.',
  },
  {
    code: 'M95',
    description:
      'Services subjected to Home Health Initiative medical review/cost report audit.',
  },
  {
    code: 'M96',
    description:
      'The technical component of a service furnished to an inpatient may only be billed by that inpatient facility. You must contact the inpatient facility for technical component reimbursement. If not already billed, you should bill us for the professional component only.',
  },
  {
    code: 'M97',
    description:
      'Not paid to practitioner when provided to patient in this place of service. Payment included in the reimbursement issued the facility.',
  },
  {
    code: 'M98',
    description:
      'Begin to report the Universal Product Number on claims for items of this type. We will soon begin to deny payment for items of this type if billed without the correct UPN.',
  },
  {
    code: 'M99',
    description:
      'Missing/incomplete/invalid Universal Product Number/Serial Number.',
  },
  {
    code: 'M100',
    description:
      'We do not pay for an oral anti-emetic drug that is not administered for use immediately before, at, or within 48 hours of administration of a covered chemotherapy drug.',
  },
  {
    code: 'M101',
    description:
      'Begin to report a G1-G5 modifier with this HCPCS. We will soon begin to deny payment for this service if billed without a G1-G5 modifier.',
  },
  {
    code: 'M102',
    description:
      'Service not performed on equipment approved by the FDA for this purpose.',
  },
  {
    code: 'M103',
    description:
      'Information supplied supports a break in therapy. However, the medical information we have for this patient does not support the need for this item as billed. We have approved payment for this item at a reduced level, and a new capped rental period will begin with the delivery of this equipment.',
  },
  {
    code: 'M104',
    description:
      'Information supplied supports a break in therapy. A new capped rental period will begin with delivery of the equipment. This is the maximum approved under the fee schedule for this item or service.',
  },
  {
    code: 'M105',
    description:
      'Information supplied does not support a break in therapy. The medical information we have for this patient does not support the need for this item as billed. We have approved payment for this item at a reduced level, and a new capped rental period will not begin.',
  },
  {
    code: 'M106',
    description:
      'Information supplied does not support a break in therapy. A new capped rental period will not begin. This is the maximum approved under the fee schedule for this item or service.',
  },
  {
    code: 'M107',
    description:
      'Payment reduced as 90-day rolling average hematocrit for ESRD patient exceeded 36.5%.',
  },
  {
    code: 'M108',
    description:
      'Missing/incomplete/invalid provider identifier for the provider who interpreted the diagnostic test.',
  },
  {
    code: 'M109',
    description:
      'We have provided you with a bundled payment for a teleconsultation. You must send 25 percent of the teleconsultation payment to the referring practitioner.',
  },
  {
    code: 'M110',
    description:
      'Missing/incomplete/invalid provider identifier for the provider from whom you purchased interpretation services.',
  },
  {
    code: 'M111',
    description:
      'We do not pay for chiropractic manipulative treatment when the patient refuses to have an x-ray taken.',
  },
  {
    code: 'M112',
    description:
      'Reimbursement for this item is based on the single payment amount required under the DMEPOS Competitive Bidding Program for the area where the patient resides.',
  },
  {
    code: 'M113',
    description:
      'Our records indicate that this patient began using this item/service prior to the current contract period for the DMEPOS Competitive Bidding Program.',
  },
  {
    code: 'M114',
    description:
      'This service was processed in accordance with rules and guidelines under the DMEPOS Competitive Bidding Program or a Demonstration Project. For more information regarding these projects, contact your local contractor.',
  },
  {
    code: 'M115',
    description:
      'This item is denied when provided to this patient by a non-contract or non-demonstration supplier.',
  },
  {
    code: 'M116',
    description:
      'Processed under a demonstration project or program. Project or program is ending and additional services may not be paid under this project or program.',
  },
  {
    code: 'M117',
    description: 'Not covered unless submitted via electronic claim.',
  },
  {
    code: 'M118',
    description: 'Letter to follow containing further information.',
  },
  {
    code: 'M119',
    description:
      'Missing/incomplete/invalid/ deactivated/withdrawn National Drug Code (NDC).',
  },
  {
    code: 'M120',
    description:
      'Missing/incomplete/invalid provider identifier for the substituting physician who furnished the service(s) under a reciprocal billing or locum tenens arrangement.',
  },
  {
    code: 'M121',
    description:
      'We pay for this service only when performed with a covered cryosurgical ablation.',
  },
  {
    code: 'M122',
    description: 'Missing/incomplete/invalid level of subluxation.',
  },
  {
    code: 'M123',
    description:
      'Missing/incomplete/invalid name, strength, or dosage of the drug furnished.',
  },
  {
    code: 'M124',
    description:
      'Missing indication of whether the patient owns the equipment that requires the part or supply.',
  },
  {
    code: 'M125',
    description:
      'Missing/incomplete/invalid information on the period of time for which the service/supply/equipment will be needed.',
  },
  {
    code: 'M126',
    description:
      'Missing/incomplete/invalid individual lab codes included in the test.',
  },
  {
    code: 'M127',
    description: 'Missing patient medical record for this service.',
  },
  {
    code: 'M128',
    description:
      "Missing/incomplete/invalid date of the patient's last physician visit.",
  },
  {
    code: 'M129',
    description:
      'Missing/incomplete/invalid indicator of x-ray availability for review.',
  },
  {
    code: 'M130',
    description:
      'Missing invoice or statement certifying the actual cost of the lens, less discounts, and/or the type of intraocular lens used.',
  },
  {
    code: 'M131',
    description: 'Missing physician financial relationship form.',
  },
  {
    code: 'M132',
    description: 'Missing pacemaker registration form.',
  },
  {
    code: 'M133',
    description:
      'Claim did not identify who performed the purchased diagnostic test or the amount you were charged for the test.',
  },
  {
    code: 'M134',
    description:
      'Performed by a facility/supplier in which the provider has a financial interest.',
  },
  {
    code: 'M135',
    description: 'Missing/incomplete/invalid plan of treatment.',
  },
  {
    code: 'M136',
    description:
      'Missing/incomplete/invalid indication that the service was supervised or evaluated by a physician.',
  },
  {
    code: 'M137',
    description:
      'Part B coinsurance under a demonstration project or pilot program.',
  },
  {
    code: 'M138',
    description:
      'Patient identified as a demonstration participant but the patient was not enrolled in the demonstration at the time services were rendered. Coverage is limited to demonstration participants.',
  },
  {
    code: 'M139',
    description:
      'Denied services exceed the coverage limit for the demonstration.',
  },
  {
    code: 'M140',
    description:
      "Service not covered until after the patient's 50th birthday, i.e., no coverage prior to the day after the 50th birthday",
  },
  {
    code: 'M141',
    description: 'Missing physician certified plan of care.',
  },
  {
    code: 'M142',
    description:
      'Missing American Diabetes Association Certificate of Recognition.',
  },
  {
    code: 'M143',
    description: 'The provider must update license information with the payer.',
  },
  {
    code: 'M144',
    description:
      'Pre-/post-operative care payment is included in the allowance for the surgery/procedure.',
  },
  {
    code: 'MA01',
    description:
      'Alert: If you do not agree with what we approved for these services, you may appeal our decision. To make sure that we are fair to you, we require another individual that did not process your initial claim to conduct the appeal. However, in order to be eligible for an appeal, you must write to us within 120 days of the date you received this notice, unless you have a good reason for being late.',
  },
  {
    code: 'MA02',
    description:
      'Alert: If you do not agree with this determination, you have the right to appeal. You must file a written request for an appeal within 180 days of the date you receive this notice.',
  },
  {
    code: 'MA03',
    description:
      'If you do not agree with the approved amounts and $100 or more is in dispute (less deductible and coinsurance), you may ask for a hearing within six months of the date of this notice. To meet the $100, you may combine amounts on other claims that have been denied, including reopened appeals if you received a revised decision. You must appeal each claim on time.',
  },
  {
    code: 'MA04',
    description:
      'Secondary payment cannot be considered without the identity of or payment information from the primary payer. The information was either not reported or was illegible.',
  },
  {
    code: 'MA05',
    description:
      'Incorrect admission date patient status or type of bill entry on claim.',
  },
  {
    code: 'MA06',
    description: 'Missing/incomplete/invalid beginning and/or ending date(s).',
  },
  {
    code: 'MA07',
    description:
      'Alert: The claim information has also been forwarded to Medicaid for review.',
  },
  {
    code: 'MA08',
    description:
      'Alert: Claim information was not forwarded because the supplemental coverage is not with a Medigap plan, or you do not participate in Medicare.',
  },
  {
    code: 'MA09',
    description:
      'Alert: Claim submitted as unassigned but processed as assigned in accordance with our current assignment/participation agreement.',
  },
  {
    code: 'MA10',
    description:
      "Alert: The patient's payment was in excess of the amount owed. You must refund the overpayment to the patient.",
  },
  {
    code: 'MA11',
    description:
      "Payment is being issued on a conditional basis. If no-fault insurance, liability insurance, Workers' Compensation, Department of Veterans Affairs, or a group health plan for employees and dependents also covers this claim, a refund may be due us. Please contact us if the patient is covered by any of these sources.",
  },
  {
    code: 'MA12',
    description:
      'You have not established that you have the right under the law to bill for services furnished by the person(s) that furnished this (these) service(s).',
  },
  {
    code: 'MA13',
    description:
      'Alert: You may be subject to penalties if you bill the patient for amounts not reported with the PR (patient responsibility) group code.',
  },
  {
    code: 'MA14',
    description:
      'Alert: The patient is a member of an employer-sponsored prepaid health plan. Services from outside that health plan are not covered. However, as you were not previously notified of this, we are paying this time. In the future, we will not pay you for non-plan services.',
  },
  {
    code: 'MA15',
    description:
      'Alert: Your claim has been separated to expedite handling. You will receive a separate notice for the other services reported.',
  },
  {
    code: 'MA16',
    description:
      'The patient is covered by the Black Lung Program. Send this claim to the Department of Labor, Federal Black Lung Program, P.O. Box 828, Lanham-Seabrook MD 20703.',
  },
  {
    code: 'MA17',
    description:
      "We are the primary payer and have paid at the primary rate. You must contact the patient's other insurer to refund any excess it may have paid due to its erroneous primary payment.",
  },
  {
    code: 'MA18',
    description:
      "Alert: The claim information is also being forwarded to the patient's supplemental insurer. Send any questions regarding supplemental benefits to them.",
  },
  {
    code: 'MA19',
    description:
      'Alert: Information was not sent to the Medigap insurer due to incorrect/invalid information you submitted concerning that insurer. Please verify your information and submit your secondary claim directly to that insurer.',
  },
  {
    code: 'MA20',
    description:
      'Skilled Nursing Facility (SNF) stay not covered when care is primarily related to the use of an urethral catheter for convenience or the control of incontinence.',
  },
  {
    code: 'MA21',
    description: 'SSA records indicate mismatch with name and sex.',
  },
  {
    code: 'MA22',
    description: 'Payment of less than $1.00 suppressed.',
  },
  {
    code: 'MA23',
    description: 'Demand bill approved as result of medical review.',
  },
  {
    code: 'MA24',
    description:
      'Christian Science Sanitarium/ Skilled Nursing Facility (SNF) bill in the same benefit period.',
  },
  {
    code: 'MA25',
    description:
      'A patient may not elect to change a hospice provider more than once in a benefit period.',
  },
  {
    code: 'MA26',
    description:
      'Alert: Our records indicate that you were previously informed of this rule.',
  },
  {
    code: 'MA27',
    description:
      'Missing/incomplete/invalid entitlement number or name shown on the claim.',
  },
  {
    code: 'MA28',
    description:
      'Alert: Receipt of this notice by a physician or supplier who did not accept assignment is for information only and does not make the physician or supplier a party to the determination. No additional rights to appeal this decision, above those rights already provided for by regulation/instruction, are conferred by receipt of this notice.',
  },
  {
    code: 'MA29',
    description:
      'Missing/incomplete/invalid provider name, city, state, or zip code.',
  },
  {
    code: 'MA30',
    description: 'Missing/incomplete/invalid type of bill.',
  },
  {
    code: 'MA31',
    description:
      'Missing/incomplete/invalid beginning and ending dates of the period billed.',
  },
  {
    code: 'MA32',
    description:
      'Missing/incomplete/invalid number of covered days during the billing period.',
  },
  {
    code: 'MA33',
    description:
      'Missing/incomplete/invalid non-covered days during the billing period.',
  },
  {
    code: 'MA34',
    description:
      'Missing/incomplete/invalid number of coinsurance days during the billing period.',
  },
  {
    code: 'MA35',
    description: 'Missing/incomplete/invalid number of lifetime reserve days.',
  },
  {
    code: 'MA36',
    description: 'Missing/incomplete/invalid patient name.',
  },
  {
    code: 'MA37',
    description: "Missing/incomplete/invalid patient's address.",
  },
  {
    code: 'MA38',
    description: 'Missing/incomplete/invalid birth date.',
  },
  {
    code: 'MA39',
    description: 'Missing/incomplete/invalid gender.',
  },
  {
    code: 'MA40',
    description: 'Missing/incomplete/invalid admission date.',
  },
  {
    code: 'MA41',
    description: 'Missing/incomplete/invalid admission type.',
  },
  {
    code: 'MA42',
    description: 'Missing/incomplete/invalid admission source.',
  },
  {
    code: 'MA43',
    description: 'Missing/incomplete/invalid patient status.',
  },
  {
    code: 'MA44',
    description: 'Alert: No appeal rights. Adjudicative decision based on law.',
  },
  {
    code: 'MA45',
    description:
      'Alert: As previously advised, a portion or all of your payment is being held in a special account.',
  },
  {
    code: 'MA46',
    description:
      'Alert: The new information was considered but additional payment will not be issued.',
  },
  {
    code: 'MA47',
    description:
      'Our records show you have opted out of Medicare, agreeing with the patient not to bill Medicare for services/tests/supplies furnished. As result, we cannot pay this claim. The patient is responsible for payment.',
  },
  {
    code: 'MA48',
    description:
      'Missing/incomplete/invalid name or address of responsible party or primary payer.',
  },
  {
    code: 'MA49',
    description:
      'Missing/incomplete/invalid six-digit provider identifier for home health agency or hospice for physician(s) performing care plan oversight services.',
  },
  {
    code: 'MA50',
    description:
      'Missing/incomplete/invalid Investigational Device Exemption number or Clinical Trial number.',
  },
  {
    code: 'MA51',
    description:
      'Missing/incomplete/invalid CLIA certification number for laboratory services billed by physician office laboratory.',
  },
  {
    code: 'MA52',
    description: 'Missing/incomplete/invalid date.',
  },
  {
    code: 'MA53',
    description:
      'Missing/incomplete/invalid Competitive Bidding Demonstration Project identification.',
  },
  {
    code: 'MA54',
    description:
      'Physician certification or election consent for hospice care not received timely.',
  },
  {
    code: 'MA55',
    description:
      'Not covered as patient received medical health care services, automatically revoking his/her election to receive religious non-medical health care services.',
  },
  {
    code: 'MA56',
    description:
      'Our records show you have opted out of Medicare, agreeing with the patient not to bill Medicare for services/tests/supplies furnished. As result, we cannot pay this claim. The patient is responsible for payment, but under Federal law, you cannot charge the patient more than the limiting charge amount.',
  },
  {
    code: 'MA57',
    description:
      'Patient submitted written request to revoke his/her election for religious non-medical health care services.',
  },
  {
    code: 'MA58',
    description: 'Missing/incomplete/invalid release of information indicator.',
  },
  {
    code: 'MA59',
    description:
      'Alert: The patient overpaid you for these services. You must issue the patient a refund within 30 days for the difference between his/her payment and the total amount shown as patient responsibility on this notice.',
  },
  {
    code: 'MA60',
    description: 'Missing/incomplete/invalid patient relationship to insured.',
  },
  {
    code: 'MA61',
    description: 'Missing/incomplete/invalid social security number.',
  },
  {
    code: 'MA62',
    description: 'Alert: This is a telephone review decision.',
  },
  {
    code: 'MA63',
    description: 'Missing/incomplete/invalid principal diagnosis.',
  },
  {
    code: 'MA64',
    description:
      'Our records indicate that we should be the third payer for this claim. We cannot process this claim until we have received payment information from the primary and secondary payers.',
  },
  {
    code: 'MA65',
    description: 'Missing/incomplete/invalid admitting diagnosis.',
  },
  {
    code: 'MA66',
    description: 'Missing/incomplete/invalid principal procedure code.',
  },
  {
    code: 'MA67',
    description: 'Alert: Correction to a prior claim.',
  },
  {
    code: 'MA68',
    description:
      'Alert: We did not crossover this claim because the secondary insurance information on the claim was incomplete. Please supply complete information or use the PLANID of the insurer to assure correct and timely routing of the claim.',
  },
  {
    code: 'MA69',
    description: 'Missing/incomplete/invalid remarks.',
  },
  {
    code: 'MA70',
    description:
      'Missing/incomplete/invalid provider representative signature.',
  },
  {
    code: 'MA71',
    description:
      'Missing/incomplete/invalid provider representative signature date.',
  },
  {
    code: 'MA72',
    description:
      'Alert: The patient overpaid you for these assigned services. You must issue the patient a refund within 30 days for the difference between his/her payment to you and the total of the amount shown as patient responsibility and as paid to the patient on this notice.',
  },
  {
    code: 'MA73',
    description:
      'Informational remittance associated with a Medicare demonstration. No payment issued under fee-for-service Medicare as patient has elected managed care.',
  },
  {
    code: 'MA74',
    description:
      'Alert: This payment replaces an earlier payment for this claim that was either lost, damaged or returned.',
  },
  {
    code: 'MA75',
    description:
      'Missing/incomplete/invalid patient or authorized representative signature.',
  },
  {
    code: 'MA76',
    description:
      'Missing/incomplete/invalid provider identifier for home health agency or hospice when physician is performing care plan oversight services.',
  },
  {
    code: 'MA77',
    description:
      "Alert: The patient overpaid you. You must issue the patient a refund within 30 days for the difference between the patient's payment less the total of our and other payer payments and the amount shown as patient responsibility on this notice.",
  },
  {
    code: 'MA78',
    description:
      'The patient overpaid you. You must issue the patient a refund within 30 days for the difference between our allowed amount total and the amount paid by the patient.',
  },
  {
    code: 'MA79',
    description: 'Billed in excess of interim rate.',
  },
  {
    code: 'MA80',
    description:
      'Informational notice. No payment issued for this claim with this notice. Payment issued to the hospital by its intermediary for all services for this encounter under a demonstration project.',
  },
  {
    code: 'MA81',
    description: 'Missing/incomplete/invalid provider/supplier signature.',
  },
  {
    code: 'MA82',
    description:
      'Missing/incomplete/invalid provider/supplier billing number/identifier or billing name, address, city, state, zip code, or phone number.',
  },
  {
    code: 'MA83',
    description:
      'Did not indicate whether we are the primary or secondary payer.',
  },
  {
    code: 'MA84',
    description:
      'Patient identified as participating in the National Emphysema Treatment Trial but our records indicate that this patient is either not a participant, or has not yet been approved for this phase of the study. Contact Johns Hopkins University, the study coordinator, to resolve if there was a discrepancy.',
  },
  {
    code: 'MA85',
    description:
      'Our records indicate that a primary payer exists (other than ourselves); however, you did not complete or enter accurately the insurance plan/group/program name or identification number. Enter the PlanID when effective.',
  },
  {
    code: 'MA86',
    description:
      'Missing/incomplete/invalid group or policy number of the insured for the primary coverage.',
  },
  {
    code: 'MA87',
    description:
      "Missing/incomplete/invalid insured's name for the primary payer.",
  },
  {
    code: 'MA88',
    description:
      "Missing/incomplete/invalid insured's address and/or telephone number for the primary payer.",
  },
  {
    code: 'MA89',
    description:
      "Missing/incomplete/invalid patient's relationship to the insured for the primary payer.",
  },
  {
    code: 'MA90',
    description:
      'Missing/incomplete/invalid employment status code for the primary insured.',
  },
  {
    code: 'MA91',
    description:
      'Alert: This determination is the result of the appeal you filed.',
  },
  {
    code: 'MA92',
    description: 'Missing plan information for other insurance.',
  },
  {
    code: 'MA93',
    description: 'Non-PIP (Periodic Interim Payment) claim.',
  },
  {
    code: 'MA94',
    description:
      "Did not enter the statement 'Attending physician not hospice employee' on the claim form to certify that the rendering physician is not an employee of the hospice.",
  },
  {
    code: 'MA95',
    description:
      'A not otherwise classified or unlisted procedure code(s) was billed but a narrative description of the procedure was not entered on the claim. Refer to item 19 on the HCFA-1500.',
  },
  {
    code: 'MA96',
    description:
      'Claim rejected. Coded as a Medicare Managed Care Demonstration but patient is not enrolled in a Medicare managed care plan.',
  },
  {
    code: 'MA97',
    description:
      'Missing/incomplete/invalid Medicare Managed Care Demonstration contract number or clinical trial registry number.',
  },
  {
    code: 'MA98',
    description:
      'Claim Rejected. Does not contain the correct Medicare Managed Care Demonstration contract number for this beneficiary.',
  },
  {
    code: 'MA99',
    description: 'Missing/incomplete/invalid Medigap information.',
  },
  {
    code: 'MA100',
    description:
      'Missing/incomplete/invalid date of current illness or symptoms.',
  },
  {
    code: 'MA101',
    description:
      'A Skilled Nursing Facility (SNF) is responsible for payment of outside providers who furnish these services/supplies to residents.',
  },
  {
    code: 'MA102',
    description:
      'Missing/incomplete/invalid name or provider identifier for the rendering/referring/ ordering/ supervising provider.',
  },
  {
    code: 'MA103',
    description: 'Hemophilia Add On.',
  },
  {
    code: 'MA104',
    description:
      'Missing/incomplete/invalid date the patient was last seen or the provider identifier of the attending physician.',
  },
  {
    code: 'MA105',
    description:
      'Missing/incomplete/invalid provider number for this place of service.',
  },
  {
    code: 'MA106',
    description: 'PIP (Periodic Interim Payment) claim.',
  },
  {
    code: 'MA107',
    description:
      'Paper claim contains more than three separate data items in field 19.',
  },
  {
    code: 'MA108',
    description: 'Paper claim contains more than one data item in field 23.',
  },
  {
    code: 'MA109',
    description:
      'Claim processed in accordance with ambulatory surgical guidelines.',
  },
  {
    code: 'MA110',
    description:
      'Missing/incomplete/invalid information on whether the diagnostic test(s) were performed by an outside entity or if no purchased tests are included on the claim.',
  },
  {
    code: 'MA111',
    description:
      "Missing/incomplete/invalid purchase price of the test(s) and/or the performing laboratory's name and address.",
  },
  {
    code: 'MA112',
    description: 'Missing/incomplete/invalid group practice information.',
  },
  {
    code: 'MA113',
    description:
      'Incomplete/invalid taxpayer identification number (TIN) submitted by you per the Internal Revenue Service. Your claims cannot be processed without your correct TIN, and you may not bill the patient pending correction of your TIN. There are no appeal rights for unprocessable claims, but you may resubmit this claim after you have notified this office of your correct TIN.',
  },
  {
    code: 'MA114',
    description:
      'Missing/incomplete/invalid information on where the services were furnished.',
  },
  {
    code: 'MA115',
    description:
      'Missing/incomplete/invalid physical location (name and address, or PIN) where the service(s) were rendered in a Health Professional Shortage Area (HPSA).',
  },
  {
    code: 'MA116',
    description:
      "Did not complete the statement 'Homebound' on the claim to validate whether laboratory services were performed at home or in an institution.",
  },
  {
    code: 'MA117',
    description: 'This claim has been assessed a $1.00 user fee.',
  },
  {
    code: 'MA118',
    description:
      'Alert: No Medicare payment issued for this claim for services or supplies furnished to a Medicare-eligible veteran through a facility of the Department of Veterans Affairs. Coinsurance and/or deductible are applicable.',
  },
  {
    code: 'MA119',
    description:
      'Provider level adjustment for late claim filing applies to this claim.',
  },
  {
    code: 'MA120',
    description: 'Missing/incomplete/invalid CLIA certification number.',
  },
  {
    code: 'MA121',
    description: 'Missing/incomplete/invalid x-ray date.',
  },
  {
    code: 'MA122',
    description: 'Missing/incomplete/invalid initial treatment date.',
  },
  {
    code: 'MA123',
    description:
      'Your center was not selected to participate in this study, therefore, we cannot pay for these services.',
  },
  {
    code: 'MA124',
    description: 'Processed for IME only.',
  },
  {
    code: 'MA125',
    description:
      'Per legislation governing this program, payment constitutes payment in full.',
  },
  {
    code: 'MA126',
    description:
      'Pancreas transplant not covered unless kidney transplant performed.',
  },
  {
    code: 'MA127',
    description: 'Reserved for future use.',
  },
  {
    code: 'MA128',
    description: 'Missing/incomplete/invalid FDA approval number.',
  },
  {
    code: 'MA129',
    description:
      'This provider was not certified for this procedure on this date of service.',
  },
  {
    code: 'MA130',
    description:
      'Your claim contains incomplete and/or invalid information, and no appeal rights are afforded because the claim is unprocessable. Please submit a new claim with the complete/correct information.',
  },
  {
    code: 'MA131',
    description:
      'Physician already paid for services in conjunction with this demonstration claim. You must have the physician withdraw that claim and refund the payment before we can process your claim.',
  },
  {
    code: 'MA132',
    description: 'Adjustment to the pre-demonstration rate.',
  },
  {
    code: 'MA133',
    description:
      'Claim overlaps inpatient stay. Rebill only those services rendered outside the inpatient stay.',
  },
  {
    code: 'MA134',
    description:
      'Missing/incomplete/invalid provider number of the facility where the patient resides.',
  },
  {
    code: 'N1',
    description:
      'Alert: You may appeal this decision in writing within the required time limits following receipt of this notice by following the instructions included in your contract, plan benefit documents or jurisdiction statutes. Refer to the URL provided in the ERA for the payer website to access the appeals process guidelines.',
  },
  {
    code: 'N2',
    description:
      'This allowance has been made in accordance with the most appropriate course of treatment provision of the plan.',
  },
  {
    code: 'N3',
    description: 'Missing consent form.',
  },
  {
    code: 'N4',
    description: 'Missing/Incomplete/Invalid prior Insurance Carrier(s) EOB.',
  },
  {
    code: 'N5',
    description: 'EOB received from previous payer. Claim not on file.',
  },
  {
    code: 'N6',
    description:
      'Under FEHB law (U.S.C. 8904(b)), we cannot pay more for covered care than the amount Medicare would have allowed if the patient were enrolled in Medicare Part A and/or Medicare Part B.',
  },
  {
    code: 'N7',
    description:
      'Alert: Processing of this claim/service has included consideration under Major Medical provisions.',
  },
  {
    code: 'N8',
    description:
      'Crossover claim denied by previous payer and complete claim data not forwarded. Resubmit this claim to this payer to provide adequate data for adjudication.',
  },
  {
    code: 'N9',
    description:
      'Adjustment represents the estimated amount a previous payer may pay.',
  },
  {
    code: 'N10',
    description:
      'Adjustment based on the findings of a review organization/professional consult/manual adjudication/medical advisor/dental advisor/peer review.',
  },
  {
    code: 'N11',
    description: 'Denial reversed because of medical review.',
  },
  {
    code: 'N12',
    description:
      'Policy provides coverage supplemental to Medicare. As the member does not appear to be enrolled in the applicable part of Medicare, the member is responsible for payment of the portion of the charge that would have been covered by Medicare.',
  },
  {
    code: 'N13',
    description:
      'Payment based on professional/technical component modifier(s).',
  },
  {
    code: 'N14',
    description:
      'Payment based on a contractual amount or agreement, fee schedule, or maximum allowable amount.',
  },
  {
    code: 'N15',
    description: 'Services for a newborn must be billed separately.',
  },
  {
    code: 'N16',
    description:
      'Family/member Out-of-Pocket maximum has been met. Payment based on a higher percentage.',
  },
  {
    code: 'N17',
    description: 'Per admission deductible.',
  },
  {
    code: 'N18',
    description: 'Payment based on the Medicare allowed amount.',
  },
  {
    code: 'N19',
    description: 'Procedure code incidental to primary procedure.',
  },
  {
    code: 'N20',
    description:
      'Service not payable with other service rendered on the same date.',
  },
  {
    code: 'N21',
    description:
      'Alert: Your line item has been separated into multiple lines to expedite handling.',
  },
  {
    code: 'N22',
    description:
      'Alert: This procedure code was added/changed because it more accurately describes the services rendered.',
  },
  {
    code: 'N23',
    description:
      'Alert: Patient liability may be affected due to coordination of benefits with other carriers and/or maximum benefit provisions.',
  },
  {
    code: 'N24',
    description:
      'Missing/incomplete/invalid Electronic Funds Transfer (EFT) banking information.',
  },
  {
    code: 'N25',
    description:
      'This company has been contracted by your benefit plan to provide administrative claims payment services only. This company does not assume financial risk or obligation with respect to claims processed on behalf of your benefit plan.',
  },
  {
    code: 'N26',
    description: 'Missing itemized bill/statement.',
  },
  {
    code: 'N27',
    description: 'Missing/incomplete/invalid treatment number.',
  },
  {
    code: 'N28',
    description: 'Consent form requirements not fulfilled.',
  },
  {
    code: 'N29',
    description: 'Missing documentation/orders/notes/summary/report/chart.',
  },
  {
    code: 'N30',
    description: 'Patient ineligible for this service.',
  },
  {
    code: 'N31',
    description: 'Missing/incomplete/invalid prescribing provider identifier.',
  },
  {
    code: 'N32',
    description:
      'Claim must be submitted by the provider who rendered the service.',
  },
  {
    code: 'N33',
    description: 'No record of health check prior to initiation of treatment.',
  },
  {
    code: 'N34',
    description: 'Incorrect claim form/format for this service.',
  },
  {
    code: 'N35',
    description: 'Program integrity/utilization review decision.',
  },
  {
    code: 'N36',
    description:
      "Claim must meet primary payer's processing requirements before we can consider payment.",
  },
  {
    code: 'N37',
    description: 'Missing/incomplete/invalid tooth number/letter.',
  },
  {
    code: 'N38',
    description: 'Missing/incomplete/invalid place of service.',
  },
  {
    code: 'N39',
    description: 'Procedure code is not compatible with tooth number/letter.',
  },
  {
    code: 'N40',
    description: 'Missing radiology film(s)/image(s).',
  },
  {
    code: 'N41',
    description: 'Authorization request denied.',
  },
  {
    code: 'N42',
    description: 'Missing mental health assessment.',
  },
  {
    code: 'N43',
    description: 'Bed hold or leave days exceeded.',
  },
  {
    code: 'N44',
    description:
      "Payer's share of regulatory surcharges, assessments, allowances or health care-related taxes paid directly to the regulatory authority.",
  },
  {
    code: 'N45',
    description: 'Payment based on authorized amount.',
  },
  {
    code: 'N46',
    description: 'Missing/incomplete/invalid admission hour.',
  },
  {
    code: 'N47',
    description: 'Claim conflicts with another inpatient stay.',
  },
  {
    code: 'N48',
    description:
      'Claim information does not agree with information received from other insurance carrier.',
  },
  {
    code: 'N49',
    description: 'Court ordered coverage information needs validation.',
  },
  {
    code: 'N50',
    description: 'Missing/incomplete/invalid discharge information.',
  },
  {
    code: 'N51',
    description:
      'Electronic interchange agreement not on file for provider/submitter.',
  },
  {
    code: 'N52',
    description:
      "Patient not enrolled in the billing provider's managed care plan on the date of service.",
  },
  {
    code: 'N53',
    description: 'Missing/incomplete/invalid point of pick-up address.',
  },
  {
    code: 'N54',
    description:
      'Claim information is inconsistent with pre-certified/authorized services.',
  },
  {
    code: 'N55',
    description:
      'Procedures for billing with group/referring/performing providers were not followed.',
  },
  {
    code: 'N56',
    description:
      'Procedure code billed is not correct/valid for the services billed or the date of service billed.',
  },
  {
    code: 'N57',
    description: 'Missing/incomplete/invalid prescribing date.',
  },
  {
    code: 'N58',
    description: 'Missing/incomplete/invalid patient liability amount.',
  },
  {
    code: 'N59',
    description:
      'Alert: Please refer to your provider manual for additional program and provider information.',
  },
  {
    code: 'N60',
    description:
      'A valid NDC is required for payment of drug claims effective October 02.',
  },
  {
    code: 'N61',
    description: 'Rebill services on separate claims.',
  },
  {
    code: 'N62',
    description:
      'Dates of service span multiple rate periods. Resubmit separate claims.',
  },
  {
    code: 'N63',
    description: 'Rebill services on separate claim lines.',
  },
  {
    code: 'N64',
    description: "The 'from' and 'to' dates must be different.",
  },
  {
    code: 'N65',
    description:
      'Procedure code or procedure rate count cannot be determined, or was not on file, for the date of service/provider.',
  },
  {
    code: 'N66',
    description: 'Missing/incomplete/invalid documentation.',
  },
  {
    code: 'N67',
    description:
      "Professional provider services not paid separately. Included in facility payment under a demonstration project. Apply to that facility for payment, or resubmit your claim if: the facility notifies you the patient was excluded from this demonstration; or if you furnished these services in another location on the date of the patient's admission or discharge from a demonstration hospital. If services were furnished in a facility not involved in the demonstration on the same date the patient was discharged from or admitted to a demonstration facility, you must report the provider ID number for the non-demonstration facility on the new claim.",
  },
  {
    code: 'N68',
    description:
      'Prior payment being cancelled as we were subsequently notified this patient was covered by a demonstration project in this site of service. Professional services were included in the payment made to the facility. You must contact the facility for your payment. Prior payment made to you by the patient or another insurer for this claim must be refunded to the payer within 30 days.',
  },
  {
    code: 'N69',
    description:
      'Alert: PPS (Prospective Payment System) code changed by claims processing system.',
  },
  {
    code: 'N70',
    description: 'Consolidated billing and payment applies.',
  },
  {
    code: 'N71',
    description:
      'Your unassigned claim for a drug or biological, clinical diagnostic laboratory services or ambulance service was processed as an assigned claim. You are required by law to accept assignment for these types of claims.',
  },
  {
    code: 'N72',
    description:
      'PPS (Prospective Payment System) code changed by medical reviewers. Not supported by clinical records.',
  },
  {
    code: 'N73',
    description:
      'A Skilled Nursing Facility is responsible for payment of outside providers who furnish these services/supplies under arrangement to its residents.',
  },
  {
    code: 'N74',
    description:
      'Resubmit with multiple claims, each claim covering services provided in only one calendar month.',
  },
  {
    code: 'N75',
    description: 'Missing/incomplete/invalid tooth surface information.',
  },
  {
    code: 'N76',
    description: 'Missing/incomplete/invalid number of riders.',
  },
  {
    code: 'N77',
    description: 'Missing/incomplete/invalid designated provider number.',
  },
  {
    code: 'N78',
    description:
      'The necessary components of the child and teen checkup (EPSDT) were not completed.',
  },
  {
    code: 'N79',
    description:
      'Service billed is not compatible with patient location information.',
  },
  {
    code: 'N80',
    description: 'Missing/incomplete/invalid prenatal screening information.',
  },
  {
    code: 'N81',
    description: 'Procedure billed is not compatible with tooth surface code.',
  },
  {
    code: 'N82',
    description:
      'Provider must accept insurance payment as payment in full when a third party payer contract specifies full reimbursement.',
  },
  {
    code: 'N83',
    description:
      'No appeal rights. Adjudicative decision based on the provisions of a demonstration project.',
  },
  {
    code: 'N84',
    description: 'Alert: Further installment payments are forthcoming.',
  },
  {
    code: 'N85',
    description: 'Alert: This is the final installment payment.',
  },
  {
    code: 'N86',
    description:
      'A failed trial of pelvic muscle exercise training is required in order for biofeedback training for the treatment of urinary incontinence to be covered.',
  },
  {
    code: 'N87',
    description: 'Home use of biofeedback therapy is not covered.',
  },
  {
    code: 'N88',
    description:
      "Alert: This payment is being made conditionally. An HHA episode of care notice has been filed for this patient. When a patient is treated under a HHA episode of care, consolidated billing requires that certain therapy services and supplies, such as this, be included in the HHA's payment. This payment will need to be recouped from you if we establish that the patient is concurrently receiving treatment under a HHA episode of care.",
  },
  {
    code: 'N89',
    description:
      'Alert: Payment information for this claim has been forwarded to more than one other payer, but format limitations permit only one of the secondary payers to be identified in this remittance advice.',
  },
  {
    code: 'N90',
    description: 'Covered only when performed by the attending physician.',
  },
  {
    code: 'N91',
    description: 'Services not included in the appeal review.',
  },
  {
    code: 'N92',
    description: 'This facility is not certified for digital mammography.',
  },
  {
    code: 'N93',
    description:
      'A separate claim must be submitted for each place of service. Services furnished at multiple sites may not be billed in the same claim.',
  },
  {
    code: 'N94',
    description:
      'Claim/Service denied because a more specific taxonomy code is required for adjudication.',
  },
  {
    code: 'N95',
    description:
      'This provider type/provider specialty may not bill this service.',
  },
  {
    code: 'N96',
    description:
      'Patient must be refractory to conventional therapy (documented behavioral, pharmacologic and/or surgical corrective therapy) and be an appropriate surgical candidate such that implantation with anesthesia can occur.',
  },
  {
    code: 'N97',
    description:
      'Patients with stress incontinence, urinary obstruction, and specific neurologic diseases (e.g., diabetes with peripheral nerve involvement) which are associated with secondary manifestations of the above three indications are excluded.',
  },
  {
    code: 'N98',
    description:
      'Patient must have had a successful test stimulation in order to support subsequent implantation. Before a patient is eligible for permanent implantation, he/she must demonstrate a 50 percent or greater improvement through test stimulation. Improvement is measured through voiding diaries.',
  },
  {
    code: 'N99',
    description:
      'Patient must be able to demonstrate adequate ability to record voiding diary data such that clinical results of the implant procedure can be properly evaluated.',
  },
  {
    code: 'N100',
    description:
      'PPS (Prospect Payment System) code corrected during adjudication.',
  },
  {
    code: 'N101',
    description:
      "Additional information is needed in order to process this claim. Please resubmit the claim with the identification number of the provider where this service took place. The Medicare number of the site of service provider should be preceded with the letters 'HSP' and entered into item #32 on the claim form. You may bill only one site of service provider number per claim.",
  },
  {
    code: 'N102',
    description:
      'This claim has been denied without reviewing the medical/dental record because the requested records were not received or were not received timely.',
  },
  {
    code: 'N103',
    description:
      'Records indicate this patient was a prisoner or in custody of a Federal, State, or local authority when the service was rendered. This payer does not cover items and services furnished to an individual while he or she is in custody under a penal statute or rule, unless under State or local law, the individual is personally liable for the cost of his or her health care while in custody and the State or local government pursues the collection of such debt in the same way and with the same vigor as the collection of its other debts. The provider can collect from the Federal/State/ Local Authority as appropriate.',
  },
  {
    code: 'N104',
    description:
      'This claim/service is not payable under our claims jurisdiction area. You can identify the correct Medicare contractor to process this claim/service through the CMS website at www.cms.gov.',
  },
  {
    code: 'N105',
    description:
      'This is a misdirected claim/service for an RRB beneficiary. Submit paper claims to the RRB carrier: Palmetto GBA, P.O. Box 10066, Augusta, GA 30999. Call 888-355-9165 for RRB EDI information for electronic claims processing.',
  },
  {
    code: 'N106',
    description:
      'Payment for services furnished to Skilled Nursing Facility (SNF) inpatients (except for excluded services) can only be made to the SNF. You must request payment from the SNF rather than the patient for this service.',
  },
  {
    code: 'N107',
    description:
      'Services furnished to Skilled Nursing Facility (SNF) inpatients must be billed on the inpatient claim. They cannot be billed separately as outpatient services.',
  },
  {
    code: 'N108',
    description: 'Missing/incomplete/invalid upgrade information.',
  },
  {
    code: 'N109',
    description: 'Alert: This claim/service was chosen for complex review.',
  },
  {
    code: 'N110',
    description: 'This facility is not certified for film mammography.',
  },
  {
    code: 'N111',
    description:
      'No appeal right except duplicate claim/service issue. This service was included in a claim that has been previously billed and adjudicated.',
  },
  {
    code: 'N112',
    description:
      'This claim is excluded from your electronic remittance advice.',
  },
  {
    code: 'N113',
    description:
      'Only one initial visit is covered per physician, group practice or provider.',
  },
  {
    code: 'N114',
    description:
      'During the transition to the Ambulance Fee Schedule, payment is based on the lesser of a blended amount calculated using a percentage of the reasonable charge/cost and fee schedule amounts, or the submitted charge for the service. You will be notified yearly what the percentages for the blended payment calculation will be.',
  },
  {
    code: 'N115',
    description:
      'This decision was based on a Local Coverage Determination (LCD). An LCD provides a guide to assist in determining whether a particular item or service is covered. A copy of this policy is available at www.cms.gov/mcd, or if you do not have web access, you may contact the contractor to request a copy of the LCD.',
  },
  {
    code: 'N116',
    description:
      "Alert: This payment is being made conditionally because the service was provided in the home, and it is possible that the patient is under a home health episode of care. When a patient is treated under a home health episode of care, consolidated billing requires that certain therapy services and supplies, such as this, be included in the home health agency's (HHA's) payment. This payment will need to be recouped from you if we establish that the patient is concurrently receiving treatment under an HHA episode of care.",
  },
  {
    code: 'N117',
    description: "This service is paid only once in a patient's lifetime.",
  },
  {
    code: 'N118',
    description:
      'This service is not paid if billed more than once every 28 days.',
  },
  {
    code: 'N119',
    description:
      'This service is not paid if billed once every 28 days, and the patient has spent 5 or more consecutive days in any inpatient or Skilled /nursing Facility (SNF) within those 28 days.',
  },
  {
    code: 'N120',
    description:
      'Payment is subject to home health prospective payment system partial episode payment adjustment. Patient was transferred/discharged/readmitted during payment episode.',
  },
  {
    code: 'N121',
    description:
      'Medicare Part B does not pay for items or services provided by this type of practitioner for beneficiaries in a Medicare Part A covered Skilled Nursing Facility (SNF) stay.',
  },
  {
    code: 'N122',
    description: 'Add-on code cannot be billed by itself.',
  },
  {
    code: 'N123',
    description:
      'Alert: This is a split service and represents a portion of the units from the originally submitted service.',
  },
  {
    code: 'N124',
    description:
      'Payment has been denied for the/made only for a less extensive service/item because the information furnished does not substantiate the need for the (more extensive) service/item. The patient is liable for the charges for this service/item as you informed the patient in writing before the service/item was furnished that we would not pay for it, and the patient agreed to pay.',
  },
  {
    code: 'N125',
    description:
      'Payment has been (denied for the/made only for a less extensive) service/item because the information furnished does not substantiate the need for the (more extensive) service/item. If you have collected any amount from the patient, you must refund that amount to the patient within 30 days of receiving this notice.',
  },
  {
    code: 'N126',
    description:
      'Social Security Records indicate that this individual has been deported. This payer does not cover items and services furnished to individuals who have been deported.',
  },
  {
    code: 'N127',
    description:
      'This is a misdirected claim/service for a United Mine Workers of America (UMWA) beneficiary. Please submit claims to them.',
  },
  {
    code: 'N128',
    description:
      'This amount represents the prior to coverage portion of the allowance.',
  },
  {
    code: 'N129',
    description: "Not eligible due to the patient's age.",
  },
  {
    code: 'N130',
    description:
      'Consult plan benefit documents/guidelines for information about restrictions for this service.',
  },
  {
    code: 'N131',
    description:
      'Total payments under multiple contracts cannot exceed the allowance for this service.',
  },
  {
    code: 'N132',
    description:
      'Alert: Payments will cease for services rendered by this US Government debarred or excluded provider after the 30 day grace period as previously notified.',
  },
  {
    code: 'N133',
    description:
      'Alert: Services for predetermination and services requesting payment are being processed separately.',
  },
  {
    code: 'N134',
    description:
      'Alert: This represents your scheduled payment for this service. If treatment has been discontinued, please contact Customer Service.',
  },
  {
    code: 'N135',
    description:
      "Record fees are the patient's responsibility and limited to the specified co-payment.",
  },
  {
    code: 'N136',
    description:
      "Alert: To obtain information on the process to file an appeal in Arizona, call the Department's Consumer Assistance Office at (602) 912-8444 or (800) 325-2548.",
  },
  {
    code: 'N137',
    description:
      "Alert: The provider acting on the Member's behalf, may file an appeal with the Payer. The provider, acting on the Member's behalf, may file a complaint with the State Insurance Regulatory Authority without first filing an appeal, if the coverage decision involves an urgent condition for which care has not been rendered. The address may be obtained from the State Insurance Regulatory Authority.",
  },
  {
    code: 'N138',
    description:
      "Alert: In the event you disagree with the Dental Advisor's opinion and have additional information relative to the case, you may submit radiographs to the Dental Advisor Unit at the subscriber's dental insurance carrier for a second Independent Dental Advisor Review.",
  },
  {
    code: 'N139',
    description:
      "Alert: Under 32 CFR 199.13, a non-participating provider is not an appropriate appealing party. Therefore, if you disagree with the Dental Advisor's opinion, you may appeal the determination if appointed in writing, by the beneficiary, to act as his/her representative. Should you be appointed as a representative, submit a copy of this letter, a signed statement explaining the matter in which you disagree, and any radiographs and relevant information to the subscriber's Dental insurance carrier within 90 days from the date of this letter.",
  },
  {
    code: 'N140',
    description:
      "Alert: You have not been designated as an authorized OCONUS provider therefore are not considered an appropriate appealing party. If the beneficiary has appointed you, in writing, to act as his/her representative and you disagree with the Dental Advisor's opinion, you may appeal by submitting a copy of this letter, a signed statement explaining the matter in which you disagree, and any relevant information to the subscriber's Dental insurance carrier within 90 days from the date of this letter.",
  },
  {
    code: 'N141',
    description:
      'The patient was not residing in a long-term care facility during all or part of the service dates billed.',
  },
  {
    code: 'N142',
    description:
      'The original claim was denied. Resubmit a new claim, not a replacement claim.',
  },
  {
    code: 'N143',
    description:
      'The patient was not in a hospice program during all or part of the service dates billed.',
  },
  {
    code: 'N144',
    description: 'The rate changed during the dates of service billed.',
  },
  {
    code: 'N145',
    description:
      'Missing/incomplete/invalid provider identifier for this place of service.',
  },
  {
    code: 'N146',
    description: 'Missing screening document.',
  },
  {
    code: 'N147',
    description:
      'Long term care case mix or per diem rate cannot be determined because the patient ID number is missing, incomplete, or invalid on the assignment request.',
  },
  {
    code: 'N148',
    description: 'Missing/incomplete/invalid date of last menstrual period.',
  },
  {
    code: 'N149',
    description: 'Rebill all applicable services on a single claim.',
  },
  {
    code: 'N150',
    description: 'Missing/incomplete/invalid model number.',
  },
  {
    code: 'N151',
    description:
      'Telephone contact services will not be paid until the face-to-face contact requirement has been met.',
  },
  {
    code: 'N152',
    description: 'Missing/incomplete/invalid replacement claim information.',
  },
  {
    code: 'N153',
    description: 'Missing/incomplete/invalid room and board rate.',
  },
  {
    code: 'N154',
    description:
      "Alert: This payment was delayed for correction of provider's mailing address.",
  },
  {
    code: 'N155',
    description:
      'Alert: Our records do not indicate that other insurance is on file. Please submit other insurance information for our records.',
  },
  {
    code: 'N156',
    description:
      'Alert: The patient is responsible for the difference between the approved treatment and the elective treatment.',
  },
  {
    code: 'N157',
    description: 'Transportation to/from this destination is not covered.',
  },
  {
    code: 'N158',
    description:
      'Transportation in a vehicle other than an ambulance is not covered.',
  },
  {
    code: 'N159',
    description:
      'Payment denied/reduced because mileage is not covered when the patient is not in the ambulance.',
  },
  {
    code: 'N160',
    description:
      'The patient must choose an option before a payment can be made for this procedure/ equipment/ supply/ service.',
  },
  {
    code: 'N161',
    description:
      'This drug/service/supply is covered only when the associated service is covered.',
  },
  {
    code: 'N162',
    description:
      'Alert: Although your claim was paid, you have billed for a test/specialty not included in your Laboratory Certification. Your failure to correct the laboratory certification information will result in a denial of payment in the near future.',
  },
  {
    code: 'N163',
    description:
      'Medical record does not support code billed per the code definition.',
  },
  {
    code: 'N164',
    description: 'Transportation to/from this destination is not covered.',
  },
  {
    code: 'N165',
    description:
      'Transportation in a vehicle other than an ambulance is not covered.',
  },
  {
    code: 'N166',
    description:
      'Payment denied/reduced because mileage is not covered when the patient is not in the ambulance.',
  },
  {
    code: 'N167',
    description: 'Charges exceed the post-transplant coverage limit.',
  },
  {
    code: 'N168',
    description:
      'The patient must choose an option before a payment can be made for this procedure/ equipment/ supply/ service.',
  },
  {
    code: 'N169',
    description:
      'This drug/service/supply is covered only when the associated service is covered.',
  },
  {
    code: 'N170',
    description:
      'A new/revised/renewed certificate of medical necessity is needed.',
  },
  {
    code: 'N171',
    description:
      'Payment for repair or replacement is not covered or has exceeded the purchase price.',
  },
  {
    code: 'N172',
    description:
      'The patient is not liable for the denied/adjusted charge(s) for receiving any updated service/item.',
  },
  {
    code: 'N173',
    description:
      'No qualifying hospital stay dates were provided for this episode of care.',
  },
  {
    code: 'N174',
    description:
      "This is not a covered service/procedure/ equipment/bed, however patient liability is limited to amounts shown in the adjustments under group 'PR'.",
  },
  {
    code: 'N175',
    description: 'Missing review organization approval.',
  },
  {
    code: 'N176',
    description:
      'Services provided aboard a ship are covered only when the ship is of United States registry and is in United States waters. In addition, a doctor licensed to practice in the United States must provide the service.',
  },
  {
    code: 'N177',
    description:
      "Alert: We did not send this claim to patient's other insurer. They have indicated no additional payment can be made.",
  },
  {
    code: 'N178',
    description: 'Missing pre-operative images/visual field results.',
  },
  {
    code: 'N179',
    description:
      'Additional information has been requested from the member. The charges will be reconsidered upon receipt of that information.',
  },
  {
    code: 'N180',
    description:
      'This item or service does not meet the criteria for the category under which it was billed.',
  },
  {
    code: 'N181',
    description:
      'Additional information is required from another provider involved in this service.',
  },
  {
    code: 'N182',
    description:
      'This claim/service must be billed according to the schedule for this plan.',
  },
  {
    code: 'N183',
    description:
      'Alert: This is a predetermination advisory message, when this service is submitted for payment additional documentation as specified in plan documents will be required to process benefits.',
  },
  {
    code: 'N184',
    description: 'Rebill technical and professional components separately.',
  },
  {
    code: 'N185',
    description: 'Alert: Do not resubmit this claim/service.',
  },
  {
    code: 'N186',
    description:
      'Non-Availability Statement (NAS) required for this service. Contact the nearest Military Treatment Facility (MTF) for assistance.',
  },
  {
    code: 'N187',
    description:
      'Alert: You may request a review in writing within the required time limits following receipt of this notice by following the instructions included in your contract or plan benefit documents.',
  },
  {
    code: 'N188',
    description:
      'The approved level of care does not match the procedure code submitted.',
  },
  {
    code: 'N189',
    description:
      "Alert: This service has been paid as a one-time exception to the plan's benefit restrictions.",
  },
  {
    code: 'N190',
    description: 'Missing contract indicator.',
  },
  {
    code: 'N191',
    description:
      'The provider must update insurance information directly with payer.',
  },
  {
    code: 'N192',
    description: 'Alert: Patient is a Medicaid/Qualified Medicare Beneficiary.',
  },
  {
    code: 'N193',
    description:
      'Alert: Specific federal/state/local program may cover this service through another payer.',
  },
  {
    code: 'N194',
    description:
      'Technical component not paid if provider does not own the equipment used.',
  },
  {
    code: 'N195',
    description: 'The technical component must be billed separately.',
  },
  {
    code: 'N196',
    description:
      'Alert: Patient eligible to apply for other coverage which may be primary.',
  },
  {
    code: 'N197',
    description:
      'The subscriber must update insurance information directly with payer.',
  },
  {
    code: 'N198',
    description:
      'Rendering provider must be affiliated with the pay-to provider.',
  },
  {
    code: 'N199',
    description:
      'Additional payment/recoupment approved based on payer-initiated review/audit.',
  },
  {
    code: 'N200',
    description: 'The professional component must be billed separately.',
  },
  {
    code: 'N201',
    description:
      'A mental health facility is responsible for payment of outside providers who furnish these services/supplies to residents.',
  },
  {
    code: 'N202',
    description:
      'Alert: Additional information/explanation will be sent separately.',
  },
  {
    code: 'N203',
    description: 'Missing/incomplete/invalid anesthesia time/units.',
  },
  {
    code: 'N204',
    description:
      'Services under review for possible pre-existing condition. Send medical records for prior 12 months',
  },
  {
    code: 'N205',
    description: 'Information provided was illegible.',
  },
  {
    code: 'N206',
    description:
      'The supporting documentation does not match the information sent on the claim.',
  },
  {
    code: 'N207',
    description: 'Missing/incomplete/invalid weight.',
  },
  {
    code: 'N208',
    description: 'Missing/incomplete/invalid DRG code.',
  },
  {
    code: 'N209',
    description:
      'Missing/incomplete/invalid taxpayer identification number (TIN).',
  },
  {
    code: 'N210',
    description: 'Alert: You may appeal this decision.',
  },
  {
    code: 'N211',
    description: 'Alert: You may not appeal this decision.',
  },
  {
    code: 'N212',
    description: 'Charges processed under a Point of Service benefit.',
  },
  {
    code: 'N213',
    description:
      'Missing/incomplete/invalid facility/discrete unit DRG/DRG exempt status information.',
  },
  {
    code: 'N214',
    description:
      'Missing/incomplete/invalid history of the related initial surgical procedure(s).',
  },
  {
    code: 'N215',
    description:
      'Alert: A payer providing supplemental or secondary coverage shall not require a claims determination for this service from a primary payer as a condition of making its own claims determination.',
  },
  {
    code: 'N216',
    description:
      'We do not offer coverage for this type of service or the patient is not enrolled in this portion of our benefit package.',
  },
  {
    code: 'N217',
    description: 'We pay only one site of service per provider per claim.',
  },
  {
    code: 'N218',
    description:
      'You must furnish and service this item for as long as the patient continues to need it. We can pay for maintenance and/or servicing for the time period specified in the contract or coverage manual.',
  },
  {
    code: 'N219',
    description: "Payment based on previous payer's allowed amount.",
  },
  {
    code: 'N220',
    description:
      "Alert: See the payer's web site or contact the payer's Customer Service department to obtain forms and instructions for filing a provider dispute.",
  },
  {
    code: 'N221',
    description: 'Missing Admitting History and Physical report.',
  },
  {
    code: 'N222',
    description: 'Incomplete/invalid Admitting History and Physical report.',
  },
  {
    code: 'N223',
    description:
      'Missing documentation of benefit to the patient during initial treatment period.',
  },
  {
    code: 'N224',
    description:
      'Incomplete/invalid documentation of benefit to the patient during initial treatment period.',
  },
  {
    code: 'N225',
    description:
      'Incomplete/invalid documentation/orders/notes/summary/report/chart.',
  },
  {
    code: 'N226',
    description:
      'Incomplete/invalid American Diabetes Association Certificate of Recognition.',
  },
  {
    code: 'N227',
    description: 'Incomplete/invalid Certificate of Medical Necessity.',
  },
  {
    code: 'N228',
    description: 'Incomplete/invalid consent form.',
  },
  {
    code: 'N229',
    description: 'Incomplete/invalid contract indicator.',
  },
  {
    code: 'N230',
    description:
      'Incomplete/invalid indication of whether the patient owns the equipment that requires the part or supply.',
  },
  {
    code: 'N231',
    description:
      'Incomplete/invalid invoice or statement certifying the actual cost of the lens, less discounts, and/or the type of intraocular lens used.',
  },
  {
    code: 'N232',
    description: 'Incomplete/invalid itemized bill/statement.',
  },
  {
    code: 'N233',
    description: 'Incomplete/invalid operative note/report.',
  },
  {
    code: 'N234',
    description: 'Incomplete/invalid oxygen certification/re-certification.',
  },
  {
    code: 'N235',
    description: 'Incomplete/invalid pacemaker registration form.',
  },
  {
    code: 'N236',
    description: 'Incomplete/invalid pathology report.',
  },
  {
    code: 'N237',
    description: 'Incomplete/invalid patient medical record for this service.',
  },
  {
    code: 'N238',
    description: 'Incomplete/invalid physician certified plan of care.',
  },
  {
    code: 'N239',
    description: 'Incomplete/invalid physician financial relationship form.',
  },
  {
    code: 'N240',
    description: 'Incomplete/invalid radiology report.',
  },
  {
    code: 'N241',
    description: 'Incomplete/invalid review organization approval.',
  },
  {
    code: 'N242',
    description: 'Incomplete/invalid radiology film(s)/image(s).',
  },
  {
    code: 'N243',
    description: 'Incomplete/invalid/not approved screening document.',
  },
  {
    code: 'N244',
    description:
      'Incomplete/Invalid pre-operative images/visual field results.',
  },
  {
    code: 'N245',
    description: 'Incomplete/invalid plan information for other insurance.',
  },
  {
    code: 'N246',
    description:
      'State regulated patient payment limitations apply to this service.',
  },
  {
    code: 'N247',
    description: 'Missing/incomplete/invalid assistant surgeon taxonomy.',
  },
  {
    code: 'N248',
    description: 'Missing/incomplete/invalid assistant surgeon name.',
  },
  {
    code: 'N249',
    description:
      'Missing/incomplete/invalid assistant surgeon primary identifier.',
  },
  {
    code: 'N250',
    description:
      'Missing/incomplete/invalid assistant surgeon secondary identifier.',
  },
  {
    code: 'N251',
    description: 'Missing/incomplete/invalid attending provider taxonomy.',
  },
  {
    code: 'N252',
    description: 'Missing/incomplete/invalid attending provider name.',
  },
  {
    code: 'N253',
    description:
      'Missing/incomplete/invalid attending provider primary identifier.',
  },
  {
    code: 'N254',
    description:
      'Missing/incomplete/invalid attending provider secondary identifier.',
  },
  {
    code: 'N255',
    description: 'Missing/incomplete/invalid billing provider taxonomy.',
  },
  {
    code: 'N256',
    description: 'Missing/incomplete/invalid billing provider/supplier name.',
  },
  {
    code: 'N257',
    description:
      'Missing/incomplete/invalid billing provider/supplier primary identifier.',
  },
  {
    code: 'N258',
    description:
      'Missing/incomplete/invalid billing provider/supplier address.',
  },
  {
    code: 'N259',
    description:
      'Missing/incomplete/invalid billing provider/supplier secondary identifier.',
  },
  {
    code: 'N260',
    description:
      'Missing/incomplete/invalid billing provider/supplier contact information.',
  },
  {
    code: 'N261',
    description: 'Missing/incomplete/invalid operating provider name.',
  },
  {
    code: 'N262',
    description:
      'Missing/incomplete/invalid operating provider primary identifier.',
  },
  {
    code: 'N263',
    description:
      'Missing/incomplete/invalid operating provider secondary identifier.',
  },
  {
    code: 'N264',
    description: 'Missing/incomplete/invalid ordering provider name.',
  },
  {
    code: 'N265',
    description:
      'Missing/incomplete/invalid ordering provider primary identifier.',
  },
  {
    code: 'N266',
    description: 'Missing/incomplete/invalid ordering provider address.',
  },
  {
    code: 'N267',
    description:
      'Missing/incomplete/invalid ordering provider secondary identifier.',
  },
  {
    code: 'N268',
    description:
      'Missing/incomplete/invalid ordering provider contact information.',
  },
  {
    code: 'N269',
    description: 'Missing/incomplete/invalid other provider name.',
  },
  {
    code: 'N270',
    description:
      'Missing/incomplete/invalid other provider primary identifier.',
  },
  {
    code: 'N271',
    description:
      'Missing/incomplete/invalid other provider secondary identifier.',
  },
  {
    code: 'N272',
    description:
      'Missing/incomplete/invalid other payer attending provider identifier.',
  },
  {
    code: 'N273',
    description:
      'Missing/incomplete/invalid other payer operating provider identifier.',
  },
  {
    code: 'N274',
    description:
      'Missing/incomplete/invalid other payer other provider identifier.',
  },
  {
    code: 'N275',
    description:
      'Missing/incomplete/invalid other payer purchased service provider identifier.',
  },
  {
    code: 'N276',
    description:
      'Missing/incomplete/invalid other payer referring provider identifier.',
  },
  {
    code: 'N277',
    description:
      'Missing/incomplete/invalid other payer rendering provider identifier.',
  },
  {
    code: 'N278',
    description:
      'Missing/incomplete/invalid other payer service facility provider identifier.',
  },
  {
    code: 'N279',
    description: 'Missing/incomplete/invalid pay-to provider name.',
  },
  {
    code: 'N280',
    description:
      'Missing/incomplete/invalid pay-to provider primary identifier.',
  },
  {
    code: 'N281',
    description: 'Missing/incomplete/invalid pay-to provider address.',
  },
  {
    code: 'N282',
    description:
      'Missing/incomplete/invalid pay-to provider secondary identifier.',
  },
  {
    code: 'N283',
    description:
      'Missing/incomplete/invalid purchased service provider identifier.',
  },
  {
    code: 'N284',
    description: 'Missing/incomplete/invalid referring provider taxonomy.',
  },
  {
    code: 'N285',
    description: 'Missing/incomplete/invalid referring provider name.',
  },
  {
    code: 'N286',
    description:
      'Missing/incomplete/invalid referring provider primary identifier.',
  },
  {
    code: 'N287',
    description:
      'Missing/incomplete/invalid referring provider secondary identifier.',
  },
  {
    code: 'N288',
    description: 'Missing/incomplete/invalid rendering provider taxonomy.',
  },
  {
    code: 'N289',
    description: 'Missing/incomplete/invalid rendering provider name.',
  },
  {
    code: 'N290',
    description:
      'Missing/incomplete/invalid rendering provider primary identifier.',
  },
  {
    code: 'N291',
    description:
      'Missing/incomplete/invalid rendering provider secondary identifier.',
  },
  {
    code: 'N292',
    description: 'Missing/incomplete/invalid service facility name.',
  },
  {
    code: 'N293',
    description:
      'Missing/incomplete/invalid service facility primary identifier.',
  },
  {
    code: 'N294',
    description: 'Missing/incomplete/invalid service facility primary address.',
  },
  {
    code: 'N295',
    description:
      'Missing/incomplete/invalid service facility secondary identifier.',
  },
  {
    code: 'N296',
    description: 'Missing/incomplete/invalid supervising provider name.',
  },
  {
    code: 'N297',
    description:
      'Missing/incomplete/invalid supervising provider primary identifier.',
  },
  {
    code: 'N298',
    description:
      'Missing/incomplete/invalid supervising provider secondary identifier.',
  },
  {
    code: 'N299',
    description: 'Missing/incomplete/invalid occurrence date(s).',
  },
  {
    code: 'N300',
    description: 'Missing/incomplete/invalid occurrence span date(s).',
  },
  {
    code: 'N301',
    description: 'Missing/incomplete/invalid procedure date(s).',
  },
  {
    code: 'N302',
    description: 'Missing/incomplete/invalid other procedure date(s).',
  },
  {
    code: 'N303',
    description: 'Missing/incomplete/invalid principal procedure date.',
  },
  {
    code: 'N304',
    description: 'Missing/incomplete/invalid dispensed date.',
  },
  {
    code: 'N305',
    description: 'Missing/incomplete/invalid injury/accident date.',
  },
  {
    code: 'N306',
    description: 'Missing/incomplete/invalid acute manifestation date.',
  },
  {
    code: 'N307',
    description: 'Missing/incomplete/invalid adjudication or payment date.',
  },
  {
    code: 'N308',
    description: 'Missing/incomplete/invalid appliance placement date.',
  },
  {
    code: 'N309',
    description: 'Missing/incomplete/invalid assessment date.',
  },
  {
    code: 'N310',
    description:
      'Missing/incomplete/invalid assumed or relinquished care date.',
  },
  {
    code: 'N311',
    description:
      'Missing/incomplete/invalid authorized to return to work date.',
  },
  {
    code: 'N312',
    description: 'Missing/incomplete/invalid begin therapy date.',
  },
  {
    code: 'N313',
    description: 'Missing/incomplete/invalid certification revision date.',
  },
  {
    code: 'N314',
    description: 'Missing/incomplete/invalid diagnosis date.',
  },
  {
    code: 'N315',
    description: 'Missing/incomplete/invalid disability from date.',
  },
  {
    code: 'N316',
    description: 'Missing/incomplete/invalid disability to date.',
  },
  {
    code: 'N317',
    description: 'Missing/incomplete/invalid discharge hour.',
  },
  {
    code: 'N318',
    description: 'Missing/incomplete/invalid discharge or end of care date.',
  },
  {
    code: 'N319',
    description:
      'Missing/incomplete/invalid hearing or vision prescription date.',
  },
  {
    code: 'N320',
    description: 'Missing/incomplete/invalid Home Health Certification Period.',
  },
  {
    code: 'N321',
    description: 'Missing/incomplete/invalid last admission period.',
  },
  {
    code: 'N322',
    description: 'Missing/incomplete/invalid last certification date.',
  },
  {
    code: 'N323',
    description: 'Missing/incomplete/invalid last contact date.',
  },
  {
    code: 'N324',
    description: 'Missing/incomplete/invalid last seen/visit date.',
  },
  {
    code: 'N325',
    description: 'Missing/incomplete/invalid last worked date.',
  },
  {
    code: 'N326',
    description: 'Missing/incomplete/invalid last x-ray date.',
  },
  {
    code: 'N327',
    description: 'Missing/incomplete/invalid other insured birth date.',
  },
  {
    code: 'N328',
    description: 'Missing/incomplete/invalid Oxygen Saturation Test date.',
  },
  {
    code: 'N329',
    description: 'Missing/incomplete/invalid patient birth date.',
  },
  {
    code: 'N330',
    description: 'Missing/incomplete/invalid patient death date.',
  },
  {
    code: 'N331',
    description: 'Missing/incomplete/invalid physician order date.',
  },
  {
    code: 'N332',
    description: 'Missing/incomplete/invalid prior hospital discharge date.',
  },
  {
    code: 'N333',
    description: 'Missing/incomplete/invalid prior placement date.',
  },
  {
    code: 'N334',
    description: 'Missing/incomplete/invalid re-evaluation date.',
  },
  {
    code: 'N335',
    description: 'Missing/incomplete/invalid referral date.',
  },
  {
    code: 'N336',
    description: 'Missing/incomplete/invalid replacement date.',
  },
  {
    code: 'N337',
    description: 'Missing/incomplete/invalid secondary diagnosis date.',
  },
  {
    code: 'N338',
    description: 'Missing/incomplete/invalid shipped date.',
  },
  {
    code: 'N339',
    description: 'Missing/incomplete/invalid similar illness or symptom date.',
  },
  {
    code: 'N340',
    description: 'Missing/incomplete/invalid subscriber birth date.',
  },
  {
    code: 'N341',
    description: 'Missing/incomplete/invalid surgery date.',
  },
  {
    code: 'N342',
    description: 'Missing/incomplete/invalid test performed date.',
  },
  {
    code: 'N343',
    description:
      'Missing/incomplete/invalid Transcutaneous Electrical Nerve Stimulator (TENS) trial start date.',
  },
  {
    code: 'N344',
    description:
      'Missing/incomplete/invalid Transcutaneous Electrical Nerve Stimulator (TENS) trial end date.',
  },
  {
    code: 'N345',
    description: 'Date range not valid with units submitted.',
  },
  {
    code: 'N346',
    description: 'Missing/incomplete/invalid oral cavity designation code.',
  },
  {
    code: 'N347',
    description:
      'Your claim for a referred or purchased service cannot be paid because payment has already been made for this same service to another provider by a payment contractor representing the payer.',
  },
  {
    code: 'N348',
    description:
      'You chose that this service/supply/drug would be rendered/supplied and billed by a different practitioner/supplier.',
  },
  {
    code: 'N349',
    description:
      'The administration method and drug must be reported to adjudicate this service.',
  },
  {
    code: 'N350',
    description:
      'Missing/incomplete/invalid description of service for a Not Otherwise Classified (NOC) code or for an Unlisted/By Report procedure.',
  },
  {
    code: 'N351',
    description:
      'Service date outside of the approved treatment plan service dates.',
  },
  {
    code: 'N352',
    description:
      'Alert: There are no scheduled payments for this service. Submit a claim for each patient visit.',
  },
  {
    code: 'N353',
    description:
      'Alert: Benefits have been estimated, when the actual services have been rendered, additional payment will be considered based on the submitted claim.',
  },
  {
    code: 'N354',
    description: 'Incomplete/invalid invoice.',
  },
  {
    code: 'N355',
    description:
      'Alert: The law permits exceptions to the refund requirement in two cases: - If you did not know, and could not have reasonably been expected to know, that we would not pay for this service; or - If you notified the patient in writing before providing the service that you believed that we were likely to deny the service, and the patient signed a statement agreeing to pay for the service.',
  },
  {
    code: 'N356',
    description:
      'Not covered when performed with, or subsequent to, a non-covered service.',
  },
  {
    code: 'N357',
    description:
      'Time frame requirements between this service/procedure/supply and a related service/procedure/supply have not been met.',
  },
  {
    code: 'N358',
    description:
      'Alert: This decision may be reviewed if additional documentation as described in the contract or plan benefit documents is submitted.',
  },
  {
    code: 'N359',
    description: 'Missing/incomplete/invalid height.',
  },
  {
    code: 'N360',
    description:
      'Alert: Coordination of benefits has not been calculated when estimating benefits for this pre-determination. Submit payment information from the primary payer with the secondary claim.',
  },
  {
    code: 'N361',
    description:
      'Payment adjusted based on multiple diagnostic imaging procedure rules',
  },
  {
    code: 'N362',
    description:
      'The number of Days or Units of Service exceeds our acceptable maximum.',
  },
  {
    code: 'N363',
    description:
      'Alert: in the near future we are implementing new policies/procedures that would affect this determination.',
  },
  {
    code: 'N364',
    description:
      'Alert: According to our agreement, you must waive the deductible and/or coinsurance amounts.',
  },
  {
    code: 'N365',
    description:
      'This procedure code is not payable. It is for reporting/information purposes only.',
  },
  {
    code: 'N366',
    description:
      'Requested information not provided. The claim will be reopened if the information previously requested is submitted within one year after the date of this denial notice.',
  },
  {
    code: 'N367',
    description:
      'Alert: The claim information has been forwarded to a Consumer Spending Account processor for review; for example, flexible spending account or health savings account.',
  },
  {
    code: 'N368',
    description:
      'You must appeal the determination of the previously adjudicated claim.',
  },
  {
    code: 'N369',
    description:
      'Alert: Although this claim has been processed, it is deficient according to state legislation/regulation.',
  },
  {
    code: 'N370',
    description:
      'Billing exceeds the rental months covered/approved by the payer.',
  },
  {
    code: 'N371',
    description:
      'Alert: title of this equipment must be transferred to the patient.',
  },
  {
    code: 'N372',
    description:
      'Only reasonable and necessary maintenance/service charges are covered.',
  },
  {
    code: 'N373',
    description:
      'It has been determined that another payer paid the services as primary when they were not the primary payer. Therefore, we are refunding to the payer that paid as primary on your behalf.',
  },
  {
    code: 'N374',
    description:
      'Primary Medicare Part A insurance has been exhausted and a Part B Remittance Advice is required.',
  },
  {
    code: 'N375',
    description:
      'Missing/incomplete/invalid questionnaire/information required to determine dependent eligibility.',
  },
  {
    code: 'N376',
    description:
      'Subscriber/patient is assigned to active military duty, therefore primary coverage may be TRICARE.',
  },
  {
    code: 'N377',
    description: 'Payment based on a processed replacement claim.',
  },
  {
    code: 'N378',
    description: 'Missing/incomplete/invalid prescription quantity.',
  },
  {
    code: 'N379',
    description:
      'Claim level information does not match line level information.',
  },
  {
    code: 'N380',
    description:
      'The original claim has been processed, submit a corrected claim.',
  },
  {
    code: 'N381',
    description:
      'Alert: Consult our contractual agreement for restrictions/billing/payment information related to these charges.',
  },
  {
    code: 'N382',
    description: 'Missing/incomplete/invalid patient identifier.',
  },
  {
    code: 'N383',
    description: 'Not covered when deemed cosmetic.',
  },
  {
    code: 'N384',
    description:
      'Records indicate that the referenced body part/tooth has been removed in a previous procedure.',
  },
  {
    code: 'N385',
    description:
      'Notification of admission was not timely according to published plan procedures.',
  },
  {
    code: 'N386',
    description:
      'This decision was based on a National Coverage Determination (NCD). An NCD provides a coverage determination as to whether a particular item or service is covered. Visit CMS.gov and search for Medicare Coverage Database to find a copy of the policy.',
  },
  {
    code: 'N387',
    description:
      "Alert: Submit this claim to the patient's other insurer for potential payment of supplemental benefits. We did not forward the claim information.",
  },
  {
    code: 'N388',
    description: 'Missing/incomplete/invalid prescription number.',
  },
  {
    code: 'N389',
    description: 'Duplicate prescription number submitted.',
  },
  {
    code: 'N390',
    description: 'This service/report cannot be billed separately.',
  },
  {
    code: 'N391',
    description: 'Missing emergency department records.',
  },
  {
    code: 'N392',
    description: 'Incomplete/invalid emergency department records.',
  },
  {
    code: 'N393',
    description: 'Missing progress notes/report.',
  },
  {
    code: 'N394',
    description: 'Incomplete/invalid progress notes/report.',
  },
  {
    code: 'N395',
    description: 'Missing laboratory report.',
  },
  {
    code: 'N396',
    description: 'Incomplete/invalid laboratory report.',
  },
  {
    code: 'N397',
    description:
      'Benefits are not available for incomplete service(s)/undelivered item(s).',
  },
  {
    code: 'N398',
    description: 'Missing elective consent form.',
  },
  {
    code: 'N399',
    description: 'Incomplete/invalid elective consent form.',
  },
  {
    code: 'N400',
    description:
      'Alert: Electronically enabled providers should submit claims electronically.',
  },
  {
    code: 'N401',
    description: 'Missing periodontal charting.',
  },
  {
    code: 'N402',
    description: 'Incomplete/invalid periodontal charting.',
  },
  {
    code: 'N403',
    description: 'Missing facility certification.',
  },
  {
    code: 'N404',
    description: 'Incomplete/invalid facility certification.',
  },
  {
    code: 'N405',
    description:
      "This service is only covered when the donor's insurer(s) do not provide coverage for the service.",
  },
  {
    code: 'N406',
    description:
      "This service is only covered when the recipient's insurer(s) do not provide coverage for the service.",
  },
  {
    code: 'N407',
    description:
      'You are not an approved submitter for this transmission format.',
  },
  {
    code: 'N408',
    description:
      'This payer does not cover deductibles assessed by a previous payer.',
  },
  {
    code: 'N409',
    description:
      'This service is related to an accidental injury and is not covered unless provided within a specific time frame from the date of the accident.',
  },
  {
    code: 'N410',
    description: 'Not covered unless the prescription changes.',
  },
  {
    code: 'N411',
    description: 'This service is allowed one time in a 6-month period.',
  },
  {
    code: 'N412',
    description: 'This service is allowed 2 times in a 12-month period.',
  },
  {
    code: 'N413',
    description: 'This service is allowed 2 times in a benefit year.',
  },
  {
    code: 'N414',
    description: 'This service is allowed 4 times in a 12-month period.',
  },
  {
    code: 'N415',
    description: 'This service is allowed 1 time in an 18-month period.',
  },
  {
    code: 'N416',
    description: 'This service is allowed 1 time in a 3-year period.',
  },
  {
    code: 'N417',
    description: 'This service is allowed 1 time in a 5-year period.',
  },
  {
    code: 'N418',
    description:
      "Misrouted claim. See the payer's claim submission instructions.",
  },
  {
    code: 'N419',
    description:
      "Claim payment was the result of a payer's retroactive adjustment due to a retroactive rate change.",
  },
  {
    code: 'N420',
    description:
      "Claim payment was the result of a payer's retroactive adjustment due to a Coordination of Benefits or Third Party Liability Recovery.",
  },
  {
    code: 'N421',
    description:
      "Claim payment was the result of a payer's retroactive adjustment due to a review organization decision.",
  },
  {
    code: 'N422',
    description:
      "Claim payment was the result of a payer's retroactive adjustment due to a payer's contract incentive program.",
  },
  {
    code: 'N423',
    description:
      "Claim payment was the result of a payer's retroactive adjustment due to a non standard program.",
  },
  {
    code: 'N424',
    description:
      'Patient does not reside in the geographic area required for this type of payment.',
  },
  {
    code: 'N425',
    description: 'Statutorily excluded service(s).',
  },
  {
    code: 'N426',
    description: 'No coverage when self-administered.',
  },
  {
    code: 'N427',
    description:
      'Payment for eyeglasses or contact lenses can be made only after cataract surgery.',
  },
  {
    code: 'N428',
    description: 'Not covered when performed in this place of service.',
  },
  {
    code: 'N429',
    description: 'Not covered when considered routine.',
  },
  {
    code: 'N430',
    description: 'Procedure code is inconsistent with the units billed.',
  },
  {
    code: 'N431',
    description: 'Not covered with this procedure.',
  },
  {
    code: 'N432',
    description: 'Alert: Adjustment based on a Recovery Audit.',
  },
  {
    code: 'N433',
    description:
      'Resubmit this claim using only your National Provider Identifier (NPI).',
  },
  {
    code: 'N434',
    description: 'Missing/Incomplete/Invalid Present on Admission indicator.',
  },
  {
    code: 'N435',
    description:
      'Exceeds number/frequency approved /allowed within time period without support documentation.',
  },
  {
    code: 'N436',
    description:
      'The injury claim has not been accepted and a mandatory medical reimbursement has been made.',
  },
  {
    code: 'N437',
    description:
      'Alert: If the injury claim is accepted, these charges will be reconsidered.',
  },
  {
    code: 'N438',
    description: 'This jurisdiction only accepts paper claims.',
  },
  {
    code: 'N439',
    description: 'Missing anesthesia physical status report/indicators.',
  },
  {
    code: 'N440',
    description:
      'Incomplete/invalid anesthesia physical status report/indicators.',
  },
  {
    code: 'N441',
    description: 'This missed/cancelled appointment is not covered.',
  },
  {
    code: 'N442',
    description: 'Payment based on an alternate fee schedule.',
  },
  {
    code: 'N443',
    description: 'Missing/incomplete/invalid total time or begin/end time.',
  },
  {
    code: 'N444',
    description:
      "Alert: This facility has not filed the Election for High Cost Outlier form with the Division of Workers' Compensation.",
  },
  {
    code: 'N445',
    description: 'Missing document for actual cost or paid amount.',
  },
  {
    code: 'N446',
    description: 'Incomplete/invalid document for actual cost or paid amount.',
  },
  {
    code: 'N447',
    description:
      'Payment is based on a generic equivalent as required documentation was not provided.',
  },
  {
    code: 'N448',
    description:
      'This drug/service/supply is not included in the fee schedule or contracted/legislated fee arrangement.',
  },
  {
    code: 'N449',
    description: 'Payment based on a comparable drug/service/supply.',
  },
  {
    code: 'N450',
    description:
      'Covered only when performed by the primary treating physician or the designee.',
  },
  {
    code: 'N451',
    description: 'Missing Admission Summary Report.',
  },
  {
    code: 'N452',
    description: 'Incomplete/invalid Admission Summary Report.',
  },
  {
    code: 'N453',
    description: 'Missing Consultation Report.',
  },
  {
    code: 'N454',
    description: 'Incomplete/invalid Consultation Report.',
  },
  {
    code: 'N455',
    description: 'Missing Physician Order.',
  },
  {
    code: 'N456',
    description: 'Incomplete/invalid Physician Order.',
  },
  {
    code: 'N457',
    description: 'Missing Diagnostic Report.',
  },
  {
    code: 'N458',
    description: 'Incomplete/invalid Diagnostic Report.',
  },
  {
    code: 'N459',
    description: 'Missing Discharge Summary.',
  },
  {
    code: 'N460',
    description: 'Incomplete/invalid Discharge Summary.',
  },
  {
    code: 'N461',
    description: 'Missing Nursing Notes.',
  },
  {
    code: 'N462',
    description: 'Incomplete/invalid Nursing Notes.',
  },
  {
    code: 'N463',
    description: 'Missing support data for claim.',
  },
  {
    code: 'N464',
    description: 'Incomplete/invalid support data for claim.',
  },
  {
    code: 'N465',
    description: 'Missing Physical Therapy Notes/Report.',
  },
  {
    code: 'N466',
    description: 'Incomplete/invalid Physical Therapy Notes/Report.',
  },
  {
    code: 'N467',
    description: 'Missing Tests and Analysis Report.',
  },
  {
    code: 'N468',
    description: 'Incomplete/invalid Report of Tests and Analysis Report.',
  },
  {
    code: 'N469',
    description:
      'Alert: Claim/Service(s) subject to appeal process, see section 935 of Medicare Prescription Drug, Improvement, and Modernization Act of 2003 (MMA).',
  },
  {
    code: 'N470',
    description:
      'This payment will complete the mandatory medical reimbursement limit.',
  },
  {
    code: 'N471',
    description: 'Missing/incomplete/invalid HIPPS Rate Code.',
  },
  {
    code: 'N472',
    description:
      'Payment for this service has been issued to another provider.',
  },
  {
    code: 'N473',
    description: 'Missing certification.',
  },
  {
    code: 'N474',
    description: 'Incomplete/invalid certification.',
  },
  {
    code: 'N475',
    description: 'Missing completed referral form.',
  },
  {
    code: 'N476',
    description: 'Incomplete/invalid completed referral form.',
  },
  {
    code: 'N477',
    description: 'Missing Dental Models.',
  },
  {
    code: 'N478',
    description: 'Incomplete/invalid Dental Models.',
  },
  {
    code: 'N479',
    description:
      'Missing Explanation of Benefits (Coordination of Benefits or Medicare Secondary Payer).',
  },
  {
    code: 'N480',
    description:
      'Incomplete/invalid Explanation of Benefits (Coordination of Benefits or Medicare Secondary Payer).',
  },
  {
    code: 'N481',
    description: 'Missing Models.',
  },
  {
    code: 'N482',
    description: 'Incomplete/invalid Models.',
  },
  {
    code: 'N483',
    description: 'Missing Periodontal Charts.',
  },
  {
    code: 'N484',
    description: 'Incomplete/invalid Periodontal Charts.',
  },
  {
    code: 'N485',
    description: 'Missing Physical Therapy Certification.',
  },
  {
    code: 'N486',
    description: 'Incomplete/invalid Physical Therapy Certification.',
  },
  {
    code: 'N487',
    description: 'Missing Prosthetics or Orthotics Certification.',
  },
  {
    code: 'N488',
    description: 'Incomplete/invalid Prosthetics or Orthotics Certification.',
  },
  {
    code: 'N489',
    description: 'Missing referral form.',
  },
  {
    code: 'N490',
    description: 'Incomplete/invalid referral form.',
  },
  {
    code: 'N491',
    description: 'Missing/Incomplete/Invalid Exclusionary Rider Condition.',
  },
  {
    code: 'N492',
    description:
      'Alert: A network provider may bill the member for this service if the member requested the service and agreed in writing, prior to receiving the service, to be financially responsible for the billed charge.',
  },
  {
    code: 'N493',
    description: 'Missing Doctor First Report of Injury.',
  },
  {
    code: 'N494',
    description: 'Incomplete/invalid Doctor First Report of Injury.',
  },
  {
    code: 'N495',
    description: 'Missing Supplemental Medical Report.',
  },
  {
    code: 'N496',
    description: 'Incomplete/invalid Supplemental Medical Report.',
  },
  {
    code: 'N497',
    description: 'Missing Medical Permanent Impairment or Disability Report.',
  },
  {
    code: 'N498',
    description:
      'Incomplete/invalid Medical Permanent Impairment or Disability Report.',
  },
  {
    code: 'N499',
    description: 'Missing Medical Legal Report.',
  },
  {
    code: 'N500',
    description: 'Incomplete/invalid Medical Legal Report.',
  },
  {
    code: 'N501',
    description: 'Missing Vocational Report.',
  },
  {
    code: 'N502',
    description: 'Incomplete/invalid Vocational Report.',
  },
  {
    code: 'N503',
    description: 'Missing Work Status Report.',
  },
  {
    code: 'N504',
    description: 'Incomplete/invalid Work Status Report.',
  },
  {
    code: 'N505',
    description:
      'Alert: This response includes only services that could be estimated in real-time. No estimate will be provided for the services that could not be estimated in real-time.',
  },
  {
    code: 'N506',
    description:
      "Alert: This is an estimate of the member's liability based on the information available at the time the estimate was processed. Actual coverage and member liability amounts will be determined when the claim is processed. This is not a pre-authorization or a guarantee of payment.",
  },
  {
    code: 'N507',
    description: 'Plan distance requirements have not been met.',
  },
  {
    code: 'N508',
    description:
      'Alert: This real-time claim adjudication response represents the member responsibility to the provider for services reported. The member will receive an Explanation of Benefits electronically or in the mail. Contact the insurer if there are any questions.',
  },
  {
    code: 'N509',
    description:
      "Alert: A current inquiry shows the member's Consumer Spending Account contains sufficient funds to cover the member liability for this claim/service. Actual payment from the Consumer Spending Account will depend on the availability of funds and determination of eligible services at the time of payment processing.",
  },
  {
    code: 'N510',
    description:
      "Alert: A current inquiry shows the member's Consumer Spending Account does not contain sufficient funds to cover the member's liability for this claim/service. Actual payment from the Consumer Spending Account will depend on the availability of funds and determination of eligible services at the time of payment processing.",
  },
  {
    code: 'N511',
    description:
      'Alert: Information on the availability of Consumer Spending Account funds to cover the member liability on this claim/service is not available at this time.',
  },
  {
    code: 'N512',
    description:
      'Alert: This is the initial remit of a non-NCPDP claim originally submitted real-time without change to the adjudication.',
  },
  {
    code: 'N513',
    description:
      'Alert: This is the initial remit of a non-NCPDP claim originally submitted real-time with a change to the adjudication.',
  },
  {
    code: 'N514',
    description:
      'Consult plan benefit documents/guidelines for information about restrictions for this service.',
  },
  {
    code: 'N515',
    description:
      "Alert: Submit this claim to the patient's other insurer for potential payment of supplemental benefits. We did not forward the claim information. (use N387 instead)",
  },
  {
    code: 'N516',
    description:
      'Records indicate a mismatch between the submitted NPI and EIN.',
  },
  {
    code: 'N517',
    description: 'Resubmit a new claim with the requested information.',
  },
  {
    code: 'N518',
    description:
      'No separate payment for accessories when furnished for use with oxygen equipment.',
  },
  {
    code: 'N519',
    description: 'Invalid combination of HCPCS modifiers.',
  },
  {
    code: 'N520',
    description: 'Alert: Payment made from a Consumer Spending Account.',
  },
  {
    code: 'N521',
    description:
      'Mismatch between the submitted provider information and the provider information stored in our system.',
  },
  {
    code: 'N522',
    description:
      'Duplicate of a claim processed, or to be processed, as a crossover claim.',
  },
  {
    code: 'N523',
    description:
      'The limitation on outlier payments defined by this payer for this service period has been met. The outlier payment otherwise applicable to this claim has not been paid.',
  },
  {
    code: 'N524',
    description: 'Based on policy this payment constitutes payment in full.',
  },
  {
    code: 'N525',
    description:
      'These services are not covered when performed within the global period of another service.',
  },
  {
    code: 'N526',
    description: 'Not qualified for recovery based on employer size.',
  },
  {
    code: 'N527',
    description:
      'We processed this claim as the primary payer prior to receiving the recovery demand.',
  },
  {
    code: 'N528',
    description:
      'Patient is entitled to benefits for Institutional Services only.',
  },
  {
    code: 'N529',
    description:
      'Patient is entitled to benefits for Professional Services only.',
  },
  {
    code: 'N530',
    description: 'Not Qualified for Recovery based on enrollment information.',
  },
  {
    code: 'N531',
    description:
      'Not qualified for recovery based on direct payment of premium.',
  },
  {
    code: 'N532',
    description:
      'Not qualified for recovery based on disability and working status.',
  },
  {
    code: 'N533',
    description:
      'Services performed in an Indian Health Services facility under a self-insured tribal Group Health Plan.',
  },
  {
    code: 'N534',
    description:
      'This is an individual policy, the employer does not participate in plan sponsorship.',
  },
  {
    code: 'N535',
    description:
      'Payment is adjusted when procedure is performed in this place of service based on the submitted procedure code and place of service.',
  },
  {
    code: 'N536',
    description:
      "We are not changing the prior payer's determination of patient responsibility, which you may collect, as this service is not covered by us.",
  },
  {
    code: 'N537',
    description:
      'We have examined claims history and no records of the services have been found.',
  },
  {
    code: 'N538',
    description:
      'A facility is responsible for payment to outside providers who furnish these services/supplies/drugs to its patients/residents.',
  },
  {
    code: 'N539',
    description:
      'Alert: We processed appeals/waiver requests on your behalf and that request has been denied.',
  },
  {
    code: 'N540',
    description: 'Payment adjusted based on the interrupted stay policy.',
  },
  {
    code: 'N541',
    description:
      'Mismatch between the submitted insurance type code and the information stored in our system.',
  },
  {
    code: 'N542',
    description: 'Missing income verification.',
  },
  {
    code: 'N543',
    description: 'Incomplete/invalid income verification.',
  },
  {
    code: 'N544',
    description:
      'Alert: Although this was paid, you have billed with a referring/ordering provider that does not match our system record. Unless corrected this will not be paid in the future.',
  },
  {
    code: 'N545',
    description:
      'Payment reduced based on status as an unsuccessful eprescriber per the Electronic Prescribing (eRx) Incentive Program.',
  },
  {
    code: 'N546',
    description:
      'Payment represents a previous reduction based on the Electronic Prescribing (eRx) Incentive Program.',
  },
  {
    code: 'N547',
    description:
      'A refund request (Frequency Type Code 8) was processed previously.',
  },
  {
    code: 'N548',
    description: "Alert: Patient's calendar year deductible has been met.",
  },
  {
    code: 'N549',
    description:
      "Alert: Patient's calendar year out-of-pocket maximum has been met.",
  },
  {
    code: 'N550',
    description:
      'Alert: You have not responded to requests to revalidate your provider/supplier enrollment information. Your failure to revalidate your enrollment information will result in a payment hold in the near future.',
  },
  {
    code: 'N551',
    description:
      'Payment adjusted based on the Ambulatory Surgical Center (ASC) Quality Reporting Program.',
  },
  {
    code: 'N552',
    description:
      'Payment adjusted to reverse a previous withhold/bonus amount.',
  },
  {
    code: 'N553',
    description:
      'Payment adjusted based on a Low Income Subsidy (LIS) retroactive coverage or status change.',
  },
  {
    code: 'N554',
    description: 'Missing/Incomplete/Invalid Family Planning Indicator.',
  },
  {
    code: 'N555',
    description: 'Missing medication list.',
  },
  {
    code: 'N556',
    description: 'Incomplete/invalid medication list.',
  },
  {
    code: 'N557',
    description:
      'This claim/service is not payable under our service area. The claim must be filed to the Payer/Plan in whose service area the specimen was collected.',
  },
  {
    code: 'N558',
    description:
      'This claim/service is not payable under our service area. The claim must be filed to the Payer/Plan in whose service area the equipment was received.',
  },
  {
    code: 'N559',
    description:
      'This claim/service is not payable under our service area. The claim must be filed to the Payer/Plan in whose service area the Ordering Physician is located.',
  },
  {
    code: 'N560',
    description:
      'The pilot program requires an interim or final claim within 60 days of the Notice of Admission. A claim was not received.',
  },
  {
    code: 'N561',
    description:
      'The bundled claim originally submitted for this episode of care includes related readmissions. You may resubmit the original claim to receive a corrected payment based on this readmission.',
  },
  {
    code: 'N562',
    description:
      'The provider number of your incoming claim does not match the provider number on the processed Notice of Admission (NOA) for this bundled payment.',
  },
  {
    code: 'N563',
    description:
      'Alert: Missing required provider/supplier issuance of advance patient notice of non-coverage. The patient is not liable for payment for this service.',
  },
  {
    code: 'N564',
    description:
      'Patient did not meet the inclusion criteria for the demonstration project or pilot program.',
  },
  {
    code: 'N565',
    description:
      'Alert: This non-payable reporting code requires a modifier. Future claims containing this non-payable reporting code must include an appropriate modifier for the claim to be processed.',
  },
  {
    code: 'N566',
    description:
      'Alert: This procedure code requires functional reporting. Future claims containing this procedure code must include an applicable non-payable code and appropriate modifiers for the claim to be processed.',
  },
  {
    code: 'N567',
    description: 'Not covered when considered preventative.',
  },
  {
    code: 'N568',
    description:
      'Alert: Initial payment based on the Notice of Admission (NOA) under the Bundled Payment Model IV initiative.',
  },
  {
    code: 'N569',
    description: 'Not covered when performed for the reported diagnosis.',
  },
  {
    code: 'N570',
    description: 'Missing/incomplete/invalid credentialing data.',
  },
  {
    code: 'N571',
    description:
      'Alert: Payment will be issued quarterly by another payer/contractor.',
  },
  {
    code: 'N572',
    description:
      'This procedure is not payable unless appropriate non-payable reporting codes and associated modifiers are submitted.',
  },
  {
    code: 'N573',
    description:
      'Alert: You have been overpaid and must refund the overpayment. The refund will be requested separately by another payer/contractor.',
  },
  {
    code: 'N574',
    description:
      'Our records indicate the ordering/referring provider is of a type/specialty that cannot order or refer. Please verify that the claim ordering/referring provider information is accurate or contact the ordering/referring provider.',
  },
  {
    code: 'N575',
    description:
      'Mismatch between the submitted ordering/referring provider name and the ordering/referring provider name stored in our records.',
  },
  {
    code: 'N576',
    description:
      'Services not related to the specific incident/claim/accident/loss being reported.',
  },
  {
    code: 'N577',
    description: 'Personal Injury Protection (PIP) Coverage.',
  },
  {
    code: 'N578',
    description: 'Coverages do not apply to this loss.',
  },
  {
    code: 'N579',
    description: 'Medical Payments Coverage (MPC).',
  },
  {
    code: 'N580',
    description:
      'Determination based on the provisions of the insurance policy.',
  },
  {
    code: 'N581',
    description: 'Investigation of coverage eligibility is pending.',
  },
  {
    code: 'N582',
    description: "Benefits suspended pending the patient's cooperation.",
  },
  {
    code: 'N583',
    description:
      'Patient was not an occupant of our insured vehicle and therefore, is not an eligible injured person.',
  },
  {
    code: 'N584',
    description:
      "Not covered based on the insured's noncompliance with policy or statutory conditions.",
  },
  {
    code: 'N585',
    description:
      'Benefits are no longer available based on a final injury settlement.',
  },
  {
    code: 'N586',
    description: 'The injured party does not qualify for benefits.',
  },
  {
    code: 'N587',
    description: 'Policy benefits have been exhausted.',
  },
  {
    code: 'N588',
    description:
      'The patient has instructed that medical claims/bills are not to be paid.',
  },
  {
    code: 'N589',
    description:
      'Coverage is excluded to any person injured as a result of operating a motor vehicle while in an intoxicated condition or while the ability to operate such a vehicle is impaired by the use of a drug.',
  },
  {
    code: 'N590',
    description:
      'Missing independent medical exam detailing the cause of injuries sustained and medical necessity of services rendered.',
  },
  {
    code: 'N591',
    description:
      'Payment based on an Independent Medical Examination (IME) or Utilization Review (UR).',
  },
  {
    code: 'N592',
    description:
      'Adjusted because this is not the initial prescription or exceeds the amount allowed for the initial prescription.',
  },
  {
    code: 'N593',
    description:
      'Not covered based on failure to attend a scheduled Independent Medical Exam (IME).',
  },
  {
    code: 'N594',
    description:
      'Records reflect the injured party did not complete an Application for Benefits for this loss.',
  },
  {
    code: 'N595',
    description:
      'Records reflect the injured party did not complete an Assignment of Benefits for this loss.',
  },
  {
    code: 'N596',
    description:
      'Records reflect the injured party did not complete a Medical Authorization for this loss.',
  },
  {
    code: 'N597',
    description:
      "Adjusted based on a medical/dental provider's apportionment of care between related injuries and other unrelated medical/dental conditions/injuries.",
  },
  {
    code: 'N598',
    description: 'Health care policy coverage is primary.',
  },
  {
    code: 'N599',
    description:
      'Our payment for this service is based upon a reasonable amount pursuant to both the terms and conditions of the policy of insurance under which the subject claim is being made as well as the Florida No-Fault Statute, which permits, when determining a reasonable charge for a service, an insurer to consider usual and customary charges and payments accepted by the provider, reimbursement levels in the community and various federal and state fee schedules applicable to automobile and other insurance coverages, and other information relevant to the reasonableness of the reimbursement for the service. The payment for this service is based upon 200% of the Participating Level of Medicare Part B fee schedule for the locale in which the services were rendered.',
  },
  {
    code: 'N600',
    description:
      'Adjusted based on the applicable fee schedule for the region in which the service was rendered.',
  },
  {
    code: 'N601',
    description:
      'In accordance with Hawaii Administrative Rules, Title 16, Chapter 23 Motor Vehicle Insurance Law payment is recommended based on Medicare Resource Based Relative Value Scale System applicable to Hawaii.',
  },
  {
    code: 'N602',
    description: 'Adjusted based on the Redbook maximum allowance.',
  },
  {
    code: 'N603',
    description:
      'This fee is calculated according to the New Jersey medical fee schedules for Automobile Personal Injury Protection and Motor Bus Medical Expense Insurance Coverage.',
  },
  {
    code: 'N604',
    description:
      "In accordance with New York No-Fault Law, Regulation 68, this base fee was calculated according to the New York Workers' Compensation Board Schedule of Medical Fees, pursuant to Regulation 83 and / or Appendix 17-C of 11 NYCRR.",
  },
  {
    code: 'N605',
    description:
      'This fee was calculated based upon New York All Patients Refined Diagnosis Related Groups (APR-DRG), pursuant to Regulation 68.',
  },
  {
    code: 'N606',
    description:
      'The Oregon allowed amount for this procedure is based upon the Workers Compensation Fee Schedule (OAR 436-009). The allowed amount has been calculated in accordance with Section 4 of ORS 742.524.',
  },
  {
    code: 'N607',
    description: 'Service provided for non-compensable condition(s).',
  },
  {
    code: 'N608',
    description:
      'The fee schedule amount allowed is calculated at 110% of the Medicare Fee Schedule for this region, specialty and type of service. This fee is calculated in compliance with Act 6.',
  },
  {
    code: 'N609',
    description:
      "80% of the provider's billed amount is being recommended for payment according to Act 6.",
  },
  {
    code: 'N610',
    description: 'Alert: Payment based on an appropriate level of care.',
  },
  {
    code: 'N611',
    description: 'Claim in litigation. Contact insurer for more information.',
  },
  {
    code: 'N612',
    description:
      'Medical provider not authorized/certified to provide treatment to injured workers in this jurisdiction.',
  },
  {
    code: 'N613',
    description:
      'Alert: Although this was paid, you have billed with an ordering provider that needs to update their enrollment record. Please verify that the ordering provider information you submitted on the claim is accurate and if it is, contact the ordering provider instructing them to update their enrollment record. Unless corrected, a claim with this ordering provider will not be paid in the future.',
  },
  {
    code: 'N614',
    description:
      'Alert: Additional information is included in the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information).',
  },
  {
    code: 'N615',
    description:
      'Alert: This enrollee receiving advance payments of the premium tax credit is in the grace period of three consecutive months for non-payment of premium. Under 45 CFR 156.270, a Qualified Health Plan issuer must pay all appropriate claims for services rendered to the enrollee during the first month of the grace period and may pend claims for services rendered to the enrollee in the second and third months of the grace period.',
  },
  {
    code: 'N616',
    description:
      'Alert: This enrollee is in the first month of the advance premium tax credit grace period.',
  },
  {
    code: 'N617',
    description:
      'This enrollee is in the second or third month of the advance premium tax credit grace period.',
  },
  {
    code: 'N618',
    description:
      'Alert: This claim will automatically be reprocessed if the enrollee pays their premiums.',
  },
  {
    code: 'N619',
    description: 'Coverage terminated for non-payment of premium.',
  },
  {
    code: 'N620',
    description:
      'Alert: This procedure code is for quality reporting/informational purposes only.',
  },
  {
    code: 'N621',
    description:
      'Charges for Jurisdiction required forms, reports, or chart notes are not payable.',
  },
  {
    code: 'N622',
    description: 'Not covered based on the date of injury/accident.',
  },
  {
    code: 'N623',
    description:
      'Not covered when deemed unscientific/unproven/outmoded/experimental/excessive/inappropriate.',
  },
  {
    code: 'N624',
    description:
      "The associated Workers' Compensation claim has been withdrawn.",
  },
  {
    code: 'N625',
    description:
      "Missing/Incomplete/Invalid Workers' Compensation Claim Number.",
  },
  {
    code: 'N626',
    description:
      'New or established patient E/M codes are not payable with chiropractic care codes.',
  },
  {
    code: 'N627',
    description: 'Service not payable per managed care contract.',
  },
  {
    code: 'N628',
    description:
      'Out-patient follow up visits on the same date of service as a scheduled test or treatment is disallowed.',
  },
  {
    code: 'N629',
    description:
      'Reviews/documentation/notes/summaries/reports/charts not requested.',
  },
  {
    code: 'N630',
    description: 'Referral not authorized by attending physician.',
  },
  {
    code: 'N631',
    description:
      'Medical Fee Schedule does not list this code. An allowance was made for a comparable service.',
  },
  {
    code: 'N632',
    description:
      'According to the Official Medical Fee Schedule this service has a relative value of zero and therefore no payment is due.',
  },
  {
    code: 'N633',
    description: 'Additional anesthesia time units are not allowed.',
  },
  {
    code: 'N634',
    description: 'The allowance is calculated based on anesthesia time units.',
  },
  {
    code: 'N635',
    description:
      'The Allowance is calculated based on the anesthesia base units plus time.',
  },
  {
    code: 'N636',
    description: 'Adjusted because this is reimbursable only once per injury.',
  },
  {
    code: 'N637',
    description:
      'Consultations are not allowed once treatment has been rendered by the same provider.',
  },
  {
    code: 'N638',
    description:
      'Reimbursement has been made according to the home health fee schedule.',
  },
  {
    code: 'N639',
    description:
      'Reimbursement has been made according to the inpatient rehabilitation facilities fee schedule.',
  },
  {
    code: 'N640',
    description:
      'Exceeds number/frequency approved/allowed within time period.',
  },
  {
    code: 'N641',
    description:
      'Reimbursement has been based on the number of body areas rated.',
  },
  {
    code: 'N642',
    description:
      'Adjusted when billed as individual tests instead of as a panel.',
  },
  {
    code: 'N643',
    description:
      'The services billed are considered Not Covered or Non-Covered (NC) in the applicable state fee schedule.',
  },
  {
    code: 'N644',
    description:
      'Reimbursement has been made according to the bilateral procedure rule.',
  },
  {
    code: 'N645',
    description: 'Mark-up allowance.',
  },
  {
    code: 'N646',
    description:
      'Reimbursement has been adjusted based on the guidelines for an assistant.',
  },
  {
    code: 'N647',
    description: 'Adjusted based on diagnosis-related group (DRG).',
  },
  {
    code: 'N648',
    description: 'Adjusted based on Stop Loss.',
  },
  {
    code: 'N649',
    description: 'Payment based on invoice.',
  },
  {
    code: 'N650',
    description:
      'This policy was not in effect for this date of loss. No coverage is available.',
  },
  {
    code: 'N651',
    description:
      'No Personal Injury Protection/Medical Payments Coverage on the policy at the time of the loss.',
  },
  {
    code: 'N652',
    description: 'The date of service is before the date of loss.',
  },
  {
    code: 'N653',
    description: 'The date of injury does not match the reported date of loss.',
  },
  {
    code: 'N654',
    description:
      'Adjusted based on achievement of maximum medical improvement (MMI).',
  },
  {
    code: 'N655',
    description: "Payment based on provider's geographic region.",
  },
  {
    code: 'N656',
    description:
      'An interest payment is being made because benefits are being paid outside the statutory requirement.',
  },
  {
    code: 'N657',
    description:
      'This should be billed with the appropriate code for these services.',
  },
  {
    code: 'N658',
    description: 'The billed service(s) are not considered medical expenses.',
  },
  {
    code: 'N659',
    description: 'This item is exempt from sales tax.',
  },
  {
    code: 'N660',
    description: 'Sales tax has been included in the reimbursement.',
  },
  {
    code: 'N661',
    description:
      'Documentation does not support that the services rendered were medically necessary.',
  },
  {
    code: 'N662',
    description:
      'Alert: Consideration of payment will be made upon receipt of a final bill.',
  },
  {
    code: 'N663',
    description: 'Adjusted based on an agreed amount.',
  },
  {
    code: 'N664',
    description: 'Adjusted based on a legal settlement.',
  },
  {
    code: 'N665',
    description: 'Services by an unlicensed provider are not reimbursable.',
  },
  {
    code: 'N666',
    description:
      'Only one evaluation and management code at this service level is covered during the course of care.',
  },
  {
    code: 'N667',
    description: 'Missing prescription.',
  },
  {
    code: 'N668',
    description: 'Incomplete/invalid prescription.',
  },
  {
    code: 'N669',
    description: 'Adjusted based on the Medicare fee schedule.',
  },
  {
    code: 'N670',
    description:
      'This service code has been identified as the primary procedure code subject to the Medicare Multiple Procedure Payment Reduction (MPPR) rule.',
  },
  {
    code: 'N671',
    description: 'Payment based on a jurisdiction cost-charge ratio.',
  },
  {
    code: 'N672',
    description: 'Alert: Amount applied to Health Insurance Offset.',
  },
  {
    code: 'N673',
    description:
      'Reimbursement has been calculated based on an outpatient per diem or an outpatient factor and/or fee schedule amount.',
  },
  {
    code: 'N674',
    description:
      'Not covered unless a pre-requisite procedure/service has been provided.',
  },
  {
    code: 'N675',
    description: 'Additional information is required from the injured party.',
  },
  {
    code: 'N676',
    description:
      'Service does not qualify for payment under the Outpatient Facility Fee Schedule.',
  },
  {
    code: 'N677',
    description: 'Alert: Films/Images will not be returned.',
  },
  {
    code: 'N678',
    description: 'Missing post-operative images/visual field results.',
  },
  {
    code: 'N679',
    description:
      'Incomplete/Invalid post-operative images/visual field results.',
  },
  {
    code: 'N680',
    description:
      'Missing/Incomplete/Invalid date of previous dental extractions.',
  },
  {
    code: 'N681',
    description: 'Missing/Incomplete/Invalid full arch series.',
  },
  {
    code: 'N682',
    description:
      'Missing/Incomplete/Invalid history of prior periodontal therapy/maintenance.',
  },
  {
    code: 'N683',
    description: 'Missing/Incomplete/Invalid prior treatment documentation.',
  },
  {
    code: 'N684',
    description:
      'Payment denied as this is a specialty claim submitted as a general claim.',
  },
  {
    code: 'N685',
    description: 'Missing/Incomplete/Invalid Prosthesis, Crown or Inlay Code.',
  },
  {
    code: 'N686',
    description:
      'Missing/incomplete/Invalid questionnaire needed to complete payment determination.',
  },
  {
    code: 'N687',
    description: 'Alert: This reversal is due to a retroactive disenrollment.',
  },
  {
    code: 'N688',
    description:
      'Alert: This reversal is due to a medical or utilization review decision.',
  },
  {
    code: 'N689',
    description: 'Alert: This reversal is due to a retroactive rate change.',
  },
  {
    code: 'N690',
    description: 'Alert: This reversal is due to a provider submitted appeal.',
  },
  {
    code: 'N691',
    description: 'Alert: This reversal is due to a patient submitted appeal.',
  },
  {
    code: 'N692',
    description:
      'Alert: This reversal is due to an incorrect rate on the initial adjudication.',
  },
  {
    code: 'N693',
    description:
      'Alert: This reversal is due to a cancellation of the claim by the provider.',
  },
  {
    code: 'N694',
    description:
      'Alert: This reversal is due to a resubmission/change to the claim by the provider.',
  },
  {
    code: 'N695',
    description:
      'Alert: This reversal is due to incorrect patient financial responsibility information on the initial adjudication.',
  },
  {
    code: 'N696',
    description:
      'Alert: This reversal is due to a Coordination of Benefits or Third Party Liability Recovery retroactive adjustment.',
  },
  {
    code: 'N697',
    description:
      "Alert: This reversal is due to a payer's retroactive contract incentive program adjustment.",
  },
  {
    code: 'N698',
    description:
      'Alert: This reversal is due to non-payment of the health insurance premiums (Health Insurance Exchange or other) by the end of the premium payment grace period, resulting in loss of coverage.',
  },
  {
    code: 'N699',
    description:
      'Payment adjusted based on the Physician Quality Reporting System (PQRS) Incentive Program.',
  },
  {
    code: 'N700',
    description:
      'Payment adjusted based on the Electronic Health Records (EHR) Incentive Program.',
  },
  {
    code: 'N701',
    description: 'Payment adjusted based on the Value-based Payment Modifier.',
  },
  {
    code: 'N702',
    description:
      'Decision based on review of previously adjudicated claims or for claims in process for the same/similar type of services.',
  },
  {
    code: 'N703',
    description:
      'This service is incompatible with previously adjudicated claims or claims in process.',
  },
  {
    code: 'N704',
    description:
      'Alert: You may not appeal this decision but can resubmit this claim/service with corrected information if warranted.',
  },
  {
    code: 'N705',
    description: 'Incomplete/invalid documentation.',
  },
  {
    code: 'N706',
    description: 'Missing documentation.',
  },
  {
    code: 'N707',
    description: 'Incomplete/invalid orders.',
  },
  {
    code: 'N708',
    description: 'Missing orders.',
  },
  {
    code: 'N709',
    description: 'Incomplete/invalid notes.',
  },
  {
    code: 'N710',
    description: 'Missing notes.',
  },
  {
    code: 'N711',
    description: 'Incomplete/invalid summary.',
  },
  {
    code: 'N712',
    description: 'Missing summary.',
  },
  {
    code: 'N713',
    description: 'Incomplete/invalid report.',
  },
  {
    code: 'N714',
    description: 'Missing report.',
  },
  {
    code: 'N715',
    description: 'Incomplete/invalid chart.',
  },
  {
    code: 'N716',
    description: 'Missing chart.',
  },
  {
    code: 'N717',
    description:
      'Incomplete/Invalid documentation of face-to-face examination.',
  },
  {
    code: 'N718',
    description: 'Missing documentation of face-to-face examination.',
  },
  {
    code: 'N719',
    description: 'Penalty applied based on plan requirements not being met.',
  },
  {
    code: 'N720',
    description:
      "Alert: The patient overpaid you. You may need to issue the patient a refund for the difference between the patient's payment and the amount shown as patient responsibility on this notice.",
  },
  {
    code: 'N721',
    description:
      'This service is only covered when performed as part of a clinical trial.',
  },
  {
    code: 'N722',
    description:
      "Patient must use Workers' Compensation Set-Aside (WCSA) funds to pay for the medical service or item.",
  },
  {
    code: 'N723',
    description:
      'Patient must use Liability set-aside (LSA) funds to pay for the medical service or item.',
  },
  {
    code: 'N724',
    description:
      'Patient must use No-Fault set-aside (NFSA) funds to pay for the medical service or item.',
  },
  {
    code: 'N725',
    description:
      'A liability insurer has reported having ongoing responsibility for medical services (ORM) for this diagnosis.',
  },
  {
    code: 'N726',
    description: 'A conditional payment is not allowed.',
  },
  {
    code: 'N727',
    description:
      'A no-fault insurer has reported having ongoing responsibility for medical services (ORM) for this diagnosis.',
  },
  {
    code: 'N728',
    description:
      "A workers' compensation insurer has reported having ongoing responsibility for medical services (ORM) for this diagnosis.",
  },
  {
    code: 'N729',
    description: 'Missing patient medical/dental record for this service.',
  },
  {
    code: 'N730',
    description:
      'Incomplete/invalid patient medical/dental record for this service.',
  },
  {
    code: 'N731',
    description: 'Incomplete/Invalid mental health assessment.',
  },
  {
    code: 'N732',
    description:
      'Services performed at an unlicensed facility are not reimbursable.',
  },
  {
    code: 'N733',
    description: 'Regulatory surcharges are paid directly to the state.',
  },
  {
    code: 'N734',
    description:
      'The patient is eligible for these medical services only when unable to work or perform normal activities due to an illness or injury.',
  },
  {
    code: 'N735',
    description:
      'Adjustment without review of medical/dental record because the requested records were not received or were not received timely.',
  },
  {
    code: 'N736',
    description: 'Incomplete/invalid Sleep Study Report.',
  },
  {
    code: 'N737',
    description: 'Missing Sleep Study Report.',
  },
  {
    code: 'N738',
    description: 'Incomplete/invalid Vein Study Report.',
  },
  {
    code: 'N739',
    description: 'Missing Vein Study Report.',
  },
  {
    code: 'N740',
    description:
      "The member's Consumer Spending Account does not contain sufficient funds to cover the member's liability for this claim/service.",
  },
  {
    code: 'N741',
    description: 'This is a site neutral payment.',
  },
  {
    code: 'N742',
    description:
      'Alert: This claim was processed based on one or more ICD-9 codes. The transition to ICD-10 is required by October 1, 2015, for health care providers, health plans, and clearinghouses. More information can be found at http://www.cms.gov/Medicare/Coding/ICD10/ProviderResources.html',
  },
  {
    code: 'N743',
    description:
      'Adjusted because the services may be related to an employment accident.',
  },
  {
    code: 'N744',
    description:
      'Adjusted because the services may be related to an auto/other accident.',
  },
  {
    code: 'N745',
    description: 'Missing Ambulance Report.',
  },
  {
    code: 'N746',
    description: 'Incomplete/invalid Ambulance Report.',
  },
  {
    code: 'N747',
    description:
      'This is a misdirected claim/service. Submit the claim to the payer/plan where the patient resides.',
  },
  {
    code: 'N748',
    description:
      'Adjusted because the related hospital charges have not been received.',
  },
  {
    code: 'N749',
    description: 'Missing Blood Gas Report.',
  },
  {
    code: 'N750',
    description: 'Incomplete/invalid Blood Gas Report.',
  },
  {
    code: 'N751',
    description:
      'Adjusted because the patient is covered under a Medicare Part D plan.',
  },
  {
    code: 'N752',
    description:
      'Missing/incomplete/invalid HIPPS Treatment Authorization Code (TAC).',
  },
  {
    code: 'N753',
    description: 'Missing/incomplete/invalid Attachment Control Number.',
  },
  {
    code: 'N754',
    description:
      'Missing/incomplete/invalid Referring Provider or Other Source Qualifier on the 1500 Claim Form.',
  },
  {
    code: 'N755',
    description: 'Missing/incomplete/invalid ICD Indicator.',
  },
  {
    code: 'N756',
    description: 'Missing/incomplete/invalid point of drop-off address.',
  },
  {
    code: 'N757',
    description: 'Adjusted based on the Federal Indian Fees schedule (MLR).',
  },
  {
    code: 'N758',
    description: 'Adjusted based on the prior authorization decision.',
  },
  {
    code: 'N759',
    description:
      'Payment adjusted based on the National Electrical Manufacturers Association (NEMA) Standard XR-29-2013.',
  },
  {
    code: 'N760',
    description:
      'This facility is not authorized to receive payment for the service(s).',
  },
  {
    code: 'N761',
    description:
      'This provider is not authorized to receive payment for the service(s).',
  },
  {
    code: 'N762',
    description:
      'This facility is not certified for Tomosynthesis (3-D) mammography.',
  },
  {
    code: 'N763',
    description:
      'The demonstration code is not appropriate for this claim; resubmit without a demonstration code.',
  },
  {
    code: 'N764',
    description: 'Missing/incomplete/invalid Hematocrit (HCT) value.',
  },
  {
    code: 'N765',
    description:
      'This payer does not cover coinsurance assessed by a previous payer.',
  },
  {
    code: 'N766',
    description:
      'This payer does not cover co-payment assessed by a previous payer.',
  },
  {
    code: 'N767',
    description:
      "The Medicaid state requires provider to be enrolled in the member's Medicaid state program prior to any claim benefits being processed.",
  },
  {
    code: 'N768',
    description: 'Incomplete/invalid initial evaluation report.',
  },
  {
    code: 'N769',
    description: 'A lateral diagnosis is required.',
  },
  {
    code: 'N770',
    description:
      'The adjustment request received from the provider has been processed. Your original claim has been adjusted based on the information received.',
  },
  {
    code: 'N771',
    description:
      'Alert: Under Federal law you cannot charge more than the limiting charge amount.',
  },
  {
    code: 'N772',
    description:
      'Alert: Rebill urgent/emergent and ancillary services separately.',
  },
  {
    code: 'N773',
    description: 'Drug supplied not obtained from specialty vendor.',
  },
  {
    code: 'N774',
    description:
      'Alert: Refer to your Third Party Processor Agreement for specific information on fees associated with this payment type.',
  },
  {
    code: 'N775',
    description: 'Payment adjusted based on x-ray radiograph on film.',
  },
  {
    code: 'N776',
    description: 'This service is not a covered Telehealth service.',
  },
  {
    code: 'N777',
    description: 'Missing Assignment of Benefits Indicator.',
  },
  {
    code: 'N778',
    description: 'Missing Primary Care Physician Information.',
  },
  {
    code: 'N779',
    description:
      'Replacement/Void claims cannot be submitted until the original claim has finalized. Please resubmit once payment or denial is received.',
  },
  {
    code: 'N780',
    description: 'Missing/incomplete/invalid end therapy date.',
  },
  {
    code: 'N781',
    description:
      'Alert: Patient is a Medicaid/ Qualified Medicare Beneficiary. Review your records for any wrongfully collected deductible. This amount may be billed to a subsequent payer.',
  },
  {
    code: 'N782',
    description:
      'Alert: Patient is a Medicaid/ Qualified Medicare Beneficiary. Review your records for any wrongfully collected coinsurance. This amount may be billed to a subsequent payer.',
  },
  {
    code: 'N783',
    description:
      'Alert: Patient is a Medicaid/ Qualified Medicare Beneficiary. Review your records for any wrongfully collected copayment. This amount may be billed to a subsequent payer.',
  },
  {
    code: 'N784',
    description: 'Missing comprehensive procedure code.',
  },
  {
    code: 'N785',
    description: 'Missing current radiology film/images.',
  },
  {
    code: 'N786',
    description:
      'Benefit limitation for the orthodontic active and/or retention phase of treatment.',
  },
  {
    code: 'N787',
    description:
      'Alert: Under 42 CFR 410.43, an eligible Partial Hospitalization Program (PHP) patient/beneficiary requires a minimum of 20 hours of PHP services per week, as evidenced in the plan of care. PHP services must be furnished in accordance with the plan of care.',
  },
  {
    code: 'N788',
    description:
      'Alert: The third-party administrator/review organization did not receive the required information.',
  },
  {
    code: 'N789',
    description: 'Clinical Trial is not a covered benefit.',
  },
  {
    code: 'N790',
    description: 'Provider/supplier not accredited for product/service.',
  },
  {
    code: 'N791',
    description: 'Missing history & physical report.',
  },
  {
    code: 'N792',
    description: 'Incomplete/invalid history & physical report.',
  },
  {
    code: 'N793',
    description:
      'Alert: Starting January 1, 2020, Medicare will ONLY accept claims submitted with the Medicare Beneficiary Identifier (MBI). Medicare will reject any claims submitted with the Health Insurance Claim Number (HICN) with a few exceptions. Please see www.cms.gov/Medicare/New-Medicare-Card/index.html for more information.',
  },
  {
    code: 'N794',
    description: 'Payment adjusted based on type of technology used.',
  },
  {
    code: 'N795',
    description: 'Item must be resubmitted as a purchase.',
  },
  {
    code: 'N796',
    description: 'Missing/incomplete/invalid Hemoglobin (Hb or Hgb) value.',
  },
  {
    code: 'N797',
    description: 'Missing/incomplete/invalid date qualifier.',
  },
  {
    code: 'N798',
    description:
      'Submit a void request for the original claim and resubmit a new claim.',
  },
  {
    code: 'N799',
    description:
      'Submitted identifier must be an individual identifier, not group identifier.',
  },
  {
    code: 'N800',
    description: 'Only one service date is allowed per claim.',
  },
  {
    code: 'N801',
    description:
      'Services performed in a Medicare participating or CAH facility under a self-insured tribal Group Health Plan, in accordance with Federal Regulation 42 CFR 136.',
  },
  {
    code: 'N802',
    description:
      'This claim/service is not payable under our service area. The claim must be filed to the Payer/Plan in whose service area the Rendering Physician is located.',
  },
  {
    code: 'N803',
    description:
      'Submission of the claim for the service rendered is the responsibility of the Contracted Medical Group or Hospital.',
  },
  {
    code: 'N804',
    description:
      'Alert: The claim/service was processed through the Outpatient Code Editor (OCE).',
  },
  {
    code: 'N805',
    description:
      'Alert: The claim/service was processed through the Correct Code Editor (CCE).',
  },
  {
    code: 'N806',
    description: 'Payment is included in the Global transplant allowance.',
  },
  {
    code: 'N807',
    description:
      'Payment adjustment based on the Merit-based Incentive Payment System (MIPS).',
  },
  {
    code: 'N808',
    description: 'Not covered for this provider type / provider specialty.',
  },
  {
    code: 'N809',
    description:
      'Alert: The fee schedule amount for this service was adjusted based on prior competitive bidding rates. For more information, contact your local contractor.',
  },
  {
    code: 'N810',
    description:
      'Alert: Due to federal, state or local disaster declaration, this claim has been processed at the in-network level of benefit. At the conclusion or expiration of the disaster declaration, network payment rules will be reinstated.',
  },
  {
    code: 'N811',
    description: 'Missing Federal Sequestration Reduction from Prior Payer.',
  },
  {
    code: 'N812',
    description:
      'The start service date through end service date cannot span greater than 18 months.',
  },
  {
    code: 'N815',
    description: 'Missing/Incomplete/Invalid NDC Unit Count',
  },
  {
    code: 'N816',
    description: 'Missing/Incomplete/Invalid NDC Unit of Measure',
  },
  {
    code: 'N817',
    description:
      'Alert: Applicable laboratories are required to collect and report private payor data and report that data to CMS between January 1, 2020 - March 31, 2020.',
  },
  {
    code: 'N818',
    description:
      'Claims Dates of Service do not match Electronic Visit Verification System.',
  },
  {
    code: 'N819',
    description:
      'Patient not enrolled in Electronic Visit Verification System.',
  },
  {
    code: 'N820',
    description:
      'Electronic Visit Verification System units do not meet requirements of visit.',
  },
  {
    code: 'N821',
    description: 'Electronic Visit Verification System visit not found.',
  },
  {
    code: 'N822',
    description: 'Missing procedure modifier(s).',
  },
  {
    code: 'N823',
    description: 'Incomplete/Invalid procedure modifier(s).',
  },
  {
    code: 'N824',
    description:
      'Electronic Visit Verification (EVV) data must be submitted through EVV Vendor.',
  },
  {
    code: 'N825',
    description: 'Early intervention guidelines were not met.',
  },
  {
    code: 'N826',
    description:
      'Patient did not meet the inclusion criteria for the Medicare Shared Savings Program.',
  },
  {
    code: 'N827',
    description:
      'Missing/Incomplete/Invalid Federal Information Processing Standard (FIPS) Code.',
  },
  {
    code: 'N828',
    description: 'Alert: Payment is suppressed due to a contracted funding.',
  },
  {
    code: 'N829',
    description:
      'Missing/incomplete/invalid Diagnostics Exchange Z-Code Identifier.',
  },
  {
    code: 'N830',
    description:
      'Alert: The charge[s] for this service was processed in accordance with Federal/ State, Balance Billing/ No Surprise Billing regulations. As such, any amount identified with OA, CO, or PI cannot be collected from the member and may be considered provider liability or be billable to a subsequent payer. Any amount the provider collected over the identified PR amount must be refunded to the patient within applicable Federal/State timeframes. Payment amounts are eligible for dispute pursuant to any Federal/State documented appeal/grievance process(es).',
  },
  {
    code: 'N831',
    description:
      'You have not responded to requests to revalidate your provider/supplier enrollment information.',
  },
  {
    code: 'N832',
    description: 'Duplicate occurrence code/occurrence span code.',
  },
  {
    code: 'N833',
    description: 'Patient share of cost waived.',
  },
  {
    code: 'N834',
    description: 'Jurisdiction exempt from sales and health tax charges.',
  },
  {
    code: 'N835',
    description:
      "Unrelated Service/procedure/treatment is reduced. The balance of this charge is the patient's responsibility.",
  },
  {
    code: 'N836',
    description: 'Provider W9 or Payee Registration not on file.',
  },
  {
    code: 'N837',
    description: 'Alert: Missing modifier was added.',
  },
  {
    code: 'N838',
    description:
      'Alert: Service/procedure postponed due to a federal, state, or local mandate/disaster declaration. Any amounts applied to deductible or member liability will be applied to the prior plan year from which the procedure was cancelled.',
  },
  {
    code: 'N839',
    description:
      'The procedure code was added/changed because the level of service exceeds the compensable condition(s).',
  },
  {
    code: 'N840',
    description: "Worker's compensation claim filed with a different state.",
  },
  {
    code: 'N841',
    description: 'Alert: North Dakota Administrative Rule 92-01-02-50.3.',
  },
  {
    code: 'N842',
    description: 'Alert: Patient cannot be billed for charges.',
  },
  {
    code: 'N843',
    description:
      'Missing/incomplete/invalid Core-Based Statistical Area (CBSA) code.',
  },
  {
    code: 'N844',
    description:
      'This claim, or a portion of this claim, was processed in accordance with the Nebraska Legislative LB997 July 24, 2020 - Out of Network Emergency Medical Care Act.',
  },
  {
    code: 'N845',
    description:
      'Alert: Nebraska Legislative LB997 July 24, 2020 - Out of Network Emergency Medical Care Act.',
  },
  {
    code: 'N846',
    description:
      'National Drug Code (NDC) supplied does not correspond to the HCPCs/CPT billed.',
  },
  {
    code: 'N847',
    description: 'National Drug Code (NDC) billed is obsolete.',
  },
  {
    code: 'N848',
    description:
      'National Drug Code (NDC) billed cannot be associated with a product.',
  },
  {
    code: 'N849',
    description:
      'Missing Tooth Clause: Tooth missing prior to the member effective date.',
  },
  {
    code: 'N850',
    description:
      'Missing/incomplete/invalid narrative explaining/describing this service/treatment.',
  },
  {
    code: 'N851',
    description:
      'Payment reduced because services were furnished by a therapy assistant.',
  },
  {
    code: 'N852',
    description:
      'The pay-to and rendering provider tax identification numbers (TINs) do not match',
  },
  {
    code: 'N853',
    description:
      'The number of modalities performed per session exceeds our acceptable maximum.',
  },
  {
    code: 'N854',
    description:
      'Alert: If you have primary other health insurance (OHI) coverage that has denied services, you must exhaust all appeal levels with your primary OHI before we can consider your claim for reimbursement.',
  },
  {
    code: 'N855',
    description:
      'This coverage is subject to the exclusive jurisdiction of ERISA (1974), U.S.C. SEC 1001.',
  },
  {
    code: 'N856',
    description:
      'This coverage is not subject to the exclusive jurisdiction of ERISA (1974), U.S.C. SEC 1001.',
  },
  {
    code: 'N857',
    description:
      'This claim has been adjusted/reversed. Refund any collected copayment to the member.',
  },
  {
    code: 'N858',
    description:
      "Alert: State regulations relating to an Out of Network Medical Emergency Care Act were applied to the processing of this claim. Payment amounts are eligible for dispute following the state's documented appeal/ grievance/ arbitration process.",
  },
  {
    code: 'N859',
    description:
      'Alert: The Federal No Surprise Billing Act was applied to the processing of this claim. Payment amounts are eligible for dispute pursuant to any Federal documented appeal/ grievance/ dispute resolution process(es).',
  },
  {
    code: 'N860',
    description:
      'Alert: The Federal No Surprise Billing Act Qualified Payment Amount (QPA) was used to calculate the member cost share(s).',
  },
  {
    code: 'N861',
    description:
      'Alert: Mismatch between the submitted Patient Liability/Share of Cost and the amount on record for this recipient.',
  },
  {
    code: 'N862',
    description:
      'Alert: Member cost share is in compliance with the No Surprises Act, and is calculated using the lesser of the QPA or billed charge.',
  },
  {
    code: 'N863',
    description:
      'Alert: This claim is subject to the No Surprises Act (NSA). The amount paid is the final out-of-network rate and was calculated based on an All Payer Model Agreement, in accordance with the NSA.',
  },
  {
    code: 'N864',
    description:
      'Alert: This claim is subject to the No Surprises Act provisions that apply to emergency services.',
  },
  {
    code: 'N865',
    description:
      'Alert: This claim is subject to the No Surprises Act provisions that apply to nonemergency services furnished by nonparticipating providers during a patient visit to a participating facility.',
  },
  {
    code: 'N866',
    description:
      'Alert: This claim is subject to the No Surprises Act provisions that apply to services furnished by nonparticipating providers of air ambulance services.',
  },
  {
    code: 'N867',
    description:
      'Alert: Cost sharing was calculated based on a specified state law, in accordance with the No Surprises Act.',
  },
  {
    code: 'N868',
    description:
      'Alert: Cost sharing was calculated based on an All-Payer Model Agreement, in accordance with the No Surprises Act.',
  },
  {
    code: 'N869',
    description:
      'Alert: Cost sharing was calculated based on the qualifying payment amount, in accordance with the No Surprises Act.',
  },
  {
    code: 'N870',
    description:
      'Alert: In accordance with the No Surprises Act, cost sharing was based on the billed amount because the billed amount was lower than the qualifying payment amount.',
  },
  {
    code: 'N871',
    description:
      'Alert: This initial payment was calculated based on a specified state law, in accordance with the No Surprises Act.',
  },
  {
    code: 'N872',
    description:
      'Alert: This final payment was calculated based on a specified state law, in accordance with the No Surprises Act.',
  },
  {
    code: 'N873',
    description:
      'Alert: This final payment was calculated based on an All-Payer Model Agreement, in accordance with the No Surprises Act.',
  },
  {
    code: 'N874',
    description:
      'Alert: This final payment was determined through open negotiation, in accordance with the No Surprises Act.',
  },
  {
    code: 'N875',
    description:
      'Alert: This final payment equals the amount selected as the out-of-network rate by a Federal Independent Dispute Resolution Entity, in accordance with the No Surprises Act.',
  },
  {
    code: 'N876',
    description:
      'Alert: This item or service is covered under the plan. This is a notice of denial of payment provided in accordance with the No Surprises Act. The provider or facility may initiate open negotiation if they desire to negotiate a higher out-of-network rate than the amount paid by the patient in cost sharing.',
  },
  {
    code: 'N877',
    description:
      'Alert: This initial payment is provided in accordance with the No Surprises Act. The provider or facility may initiate open negotiation if they desire to negotiate a higher out-of-network rate.',
  },
  {
    code: 'N878',
    description:
      'Alert: The provider or facility specified that notice was provided and consent to balance bill obtained, but notice and consent was not provided and obtained in a manner consistent with applicable Federal law. Thus, cost sharing and the total amount paid have been calculated based on the requirements under the No Surprises Act, and balance billing is prohibited.',
  },
  {
    code: 'N879',
    description:
      'Alert: The notice and consent to balance bill, and to be charged out-of-network cost sharing, that was obtained from the patient with regard to the billed services, is not permitted for these services. Thus, cost sharing and the total amount paid have been calculated based on the requirements under the No Surprises Act, and balance billing is prohibited.',
  },
  {
    code: 'N880',
    description:
      'Original claim closed due to changes in submitted data. Adjustment claim will be processed under a new claim number.',
  },
  {
    code: 'N881',
    description:
      'Client Obligation, patient responsibility for Home & Community Based Services (HCBS)',
  },
  {
    code: 'N882',
    description:
      "Alert: The out-of-network payment and cost sharing amounts were based on the plan's allowance because the provider or facility obtained the patient's consent to waive the balance billing protections under the No Surprises Act.",
  },
  {
    code: 'N883',
    description: 'Alert: Processed according to state law',
  },
  {
    code: 'N884',
    description:
      'Alert: The No Surprises Act may apply to this claim. Please contact payer for instructions on how to submit information regarding whether or not the item or service was furnished during a patient visit to a participating facility.',
  },
  {
    code: 'N885',
    description:
      'Alert: This claim was not processed in accordance with the No Surprises Act cost-sharing or out-of-network payment requirements. The payer disagrees with your determination that those requirements apply. You may contact the payer to find out why it disagrees. You may appeal this adverse determination on behalf of the patient through the payer’s internal appeals and external review processes.',
  },
  {
    code: 'N886',
    description:
      'Alert: A Health Care Claim Request for Additional Information (277 RFAI) has been sent.',
  },
  {
    code: 'N887',
    description:
      'Providers not participating in the Medicare Advantage Plan have the right to appeal if the plan has partially or fully denied payment or if the provider believes the plan has not paid the services at the expected Medicare reimbursable rate or type of level/service. Providers may file their appeal in writing within 60 calendar days after the date of the remittance advice. For the plan to review the appeal, the plan will need a completed signed Waiver of Liability Statement. To obtain a Waiver of Liability form, please contact your Medicare Advantage Plan.',
  },
  {
    code: 'N888',
    description:
      'Alert: An electronic request for additional information has been sent for this claim.',
  },
  {
    code: 'N889',
    description:
      'Alert: This claim was originally processed in real-time, and we sent a real-time 835 response.',
  },
  {
    code: 'N890',
    description:
      'Electronic Visit Verification Data Element Requirements were not met.',
  },
  {
    code: 'N891',
    description:
      'The maximum allowable payment for this service/procedure was paid by the primary insurance. No further payment due.',
  },
  {
    code: 'N892',
    description:
      'The claim does not meet the criteria for acceptable use of the Delay Reason Code.',
  },
  {
    code: 'N893',
    description:
      'Missing/incomplete/invalid child medical evaluation form/checklist.',
  },
  {
    code: 'N894',
    description:
      "Alert: These payments are made subject to a reservation of rights for the Payor to recoup or otherwise recover all or part of these payments based on any of the following: outcome of pending or future litigation/ new or updated state, federal or regulatory guidance/ any other actions that may affect the Payor's obligation to make these payments.",
  },
  {
    code: 'N895',
    description:
      'Processed based on a negotiated fee schedule for a specialty drug program.',
  },
  {
    code: 'N896',
    description: 'Missing/incomplete/invalid trauma activation sheet.',
  },
  {
    code: 'N897',
    description: 'Missing/incomplete/invalid proof of member payment.',
  },
  {
    code: 'N898',
    description:
      'Missing/incomplete/invalid Resource Utilization Group(s) (RUG) code(s).',
  },
  {
    code: 'N899',
    description: 'Missing Initial Evaluation Report.',
  },
  {
    code: 'N900',
    description: 'Missing Therapy Notes/Report.',
  },
  {
    code: 'N901',
    description: 'Incomplete/Invalid Therapy Notes/Report.',
  },
  {
    code: 'N902',
    description: 'Missing Health Risk Assessment (HRA).',
  },
  {
    code: 'N903',
    description: 'Incomplete/Invalid Health Risk Assessment (HRA).',
  },
  {
    code: 'N904',
    description: 'The transportation vendor is responsible for this claim.',
  },
  {
    code: 'N905',
    description:
      'Our records show you have opted out of Medicare, agreeing with the patient not to bill Medicare for services/tests/supplies furnished. As result, we cannot pay this claim. The patient is not responsible for payment.',
  },
  {
    code: 'N906',
    description: 'Service is not covered when patient is under age 45.',
  },
  {
    code: 'N907',
    description:
      'No refund because this claim has been identified as 340B-eligible with a ceiling price lower than the maximum fair price.',
  },
  {
    code: 'N908',
    description:
      'No refund because this drug has been prospectively purchased at the maximum fair price.',
  },
  {
    code: 'N909',
    description:
      'Refund amount has been calculated using a methodology that differs from the Standard Default Refund Amount calculation ((Wholesale Acquisition Cost minus Maximum Fair Price) times Quantity).',
  },
  {
    code: 'N910',
    description:
      'A refund cannot be provided for this claim at this time. Contact the manufacturer directly regarding your eligibility.',
  },
  {
    code: 'N911',
    description:
      'This claim cannot be reimbursed by the manufacturer until the Part D plan submits corrected prescription drug event data to CMS for maximum fair price validation.',
  },
  {
    code: 'N912',
    description:
      'Our records indicate that this beneficiary did not elect hospice.',
  },
  {
    code: 'N913',
    description:
      'More than one Electronic Visit Verification record exists for the date and time of this service.',
  },
  {
    code: 'N914',
    description:
      'This claim was priced and processed in accordance with California AB-72 Health care coverage.',
  },
  {
    code: 'N915',
    description:
      "Predetermination of services is not allowed under the member's plan.",
  },
  {
    code: 'N916',
    description:
      'The third party will render payment to the provider, and they will reimburse you for covered services.',
  },
  {
    code: 'N917',
    description:
      'Alternative refund amount has been calculated because the maximum fair price is below the 340B ceiling price.',
  },
  {
    code: 'N918',
    description:
      'No refund because CMS excludes prescription drug event records when a compound code indicates it is for a compounded drug.',
  },
  {
    code: 'N919',
    description: 'Family/member out-of-pocket maximum has been met.',
  },
  {
    code: 'N920',
    description:
      'Payment to the provider has been placed on hold as a result of active contract (re)negotiation.',
  },
  {
    code: 'N921',
    description:
      'The time limit for filing a reconsideration or appeal has expired.',
  },
  {
    code: 'N922',
    description: 'Missing primary care dentist information.',
  },
  {
    code: 'N923',
    description:
      'Not Denied - The Medicare Advantage Organization (MAO) made a payment responsibility determination.',
  },
  {
    code: 'N924',
    description:
      'Pending (Not Denied) - The Medicare Advantage Organization (MAO) has not yet made a payment responsibility determination for the service at the time the encounter record was submitted.',
  },
  {
    code: 'N925',
    description:
      'Denied - The Medicare Advantage Organization (MAO) determined that it had no payment responsibility for the service at the time the encounter record was submitted.',
  },
  {
    code: 'N926',
    description:
      'Partially Denied - The Medicare Advantage Organization (MAO) determined that it had no payment responsibility for one or more service lines, but not all, at the time the encounter record was submitted.',
  },
  {
    code: 'N927',
    description: 'Missing/Incomplete/Invalid x-ray.',
  },
  {
    code: 'N928',
    description: 'Missing/Incomplete/Invalid bitewing or periapical x-ray.',
  },
  {
    code: 'N929',
    description: 'Missing/Incomplete/Invalid photo(s).',
  },
  {
    code: 'N930',
    description: 'Missing/Incomplete/Invalid quadrant identifier.',
  },
  {
    code: 'N931',
    description:
      'Missing/Incomplete/Invalid pre- and/or post-operative bitewing or periapical x-ray.',
  },
  {
    code: 'N932',
    description:
      'Missing/Incomplete/Invalid pre- and/or post-operative full mouth x-ray.',
  },
  {
    code: 'N933',
    description:
      'Missing/Incomplete/Invalid pre- and/or post-operative photo(s).',
  },
  {
    code: 'N934',
    description: 'Missing/Incomplete/Invalid full mouth x-ray.',
  },
  {
    code: 'N935',
    description:
      'Alert: Patient is no longer a Medicaid/Qualified Medicare Beneficiary.',
  },
  {
    code: 'N936',
    description:
      'This service code has been identified as the secondary or tertiary procedure code subject to the Medicare Multiple Procedure Payment Reduction (MPPR) rule.',
  },
  {
    code: 'N937',
    description: 'The service line denial threshold was exceeded.',
  },
  {
    code: 'N938',
    description:
      'Alert: Do not resubmit. This claim will be automatically reprocessed.',
  },
  {
    code: 'N939',
    description: 'Alert: You may contact us for a peer-to-peer review.',
  },
  {
    code: 'N940',
    description: 'Missing/Incomplete/Invalid pre- and/or post-operative x-ray.',
  },
];
